const translations = {
    'home': {
        en: 'home',
        pt: 'início',
        es: 'home'
    },
    'articles': {
        en: 'articles',
        pt: 'artigos',
        es: 'artículos'
    },
    'register': {
        en: 'register',
        pt: 'cadastrar',
        es: 'registrar'
    },
    'enter': {
        en: 'enter',
        pt: 'entrar',
        es: 'entrar'
    },
    'english': {
        en: 'english',
        pt: 'inglês',
        es: 'inglés'
    },
    'portuguese': {
        en: 'portuguese',
        pt: 'português',
        es: 'portugués'
    },
    'spanish': {
        en: 'spanish',
        pt: 'espanhol',
        es: 'español'
    },
    'my learning': {
        en: 'my learning',
        pt: 'meu aprendizado',
        es: 'mi aprendizaje'
    },
    'my cart': {
        en: 'my cart',
        pt: 'meu carrinho',
        es: 'mi carrito'
    },
    'notifications': {
        en: 'notifications',
        pt: 'notificações',
        es: 'notificaciones'
    },
    'messages': {
        en: 'messages',
        pt: 'mensagens',
        es: 'mensajes'
    },
    'account configuration': {
        en: 'account configuration',
        pt: 'configuração da conta',
        es: 'configuración de la cuenta'
    },
    'purchase history': {
        en: 'purchase history',
        pt: 'histórico de compra',
        es: 'historial de compras'
    },
    'support': {
        en: 'support',
        pt: 'suporte',
        es: 'soporte'
    },
    'success': {
        en: 'Success',
        pt: 'Sucesso',
        es: 'Exito'
    },
    'error': {
        en: 'Error',
        pt: 'Erro',
        es: 'Erro'
    },
    'help and support': {
        en: 'help and support',
        pt: 'ajuda e suporte',
        es: 'ayuda y soporte'
    },
    'language': {
        en: 'language',
        pt: 'idioma',
        es: 'idioma'
    },
    'my courses': {
        en: 'my courses',
        pt: 'meus cursos',
        es: 'mis cursos'
    },
    'courses': {
        en: 'courses',
        pt: 'cursos',
        es: 'cursos'
    },
    'categories': {
        en: 'categories',
        pt: 'categorias',
        es: 'categorías'
    },
    'about post': {
        en: 'about post',
        pt: 'postagem sobre',
        es: 'sobre la publicación'
    },
    'exclusive materials': {
        en: 'exclusive materials',
        pt: 'materiais exclusivos',
        es: 'materiales exclusivos'
    },
    'support callings': {
        en: 'support callings',
        pt: 'chamados de suporte',
        es: 'tickets de soporte'
    },
    'wait some minutes before sending another email': {
        en: 'wait some minutes before sending another email',
        pt: 'aguarde alguns minutos antes de enviar outro email',
        es: 'espere unos minutos antes de enviar otro correo electrónico'
    },
    'online english with': {
        en: 'online english with',
        pt: 'inglês online com',
        es: 'inglés online para que'
    },
    'grace, freedom, and purpose': {
        en: 'grace, freedom, and purpose',
        pt: 'leveza, liberdade e propósito',
        es: 'te sientas libre, seguro y con propósito'
    },
    'no pressure, no one-size-fits-all formulas': {
        en: 'no pressure, no one-size-fits-all formulas',
        pt: 'sem pressão, sem fórmulas prontas',
        es: 'Sin presión, sin fórmulas predefinidas'
    },
    'a learning experience that': {
        en: 'a learning experience that',
        pt: 'um ensino que',
        es: 'Un aprendizaje que'
    },
    'respects your pace': {
        en: 'respects your pace',
        pt: 'respeita o seu tempo',
        es: 'respeta tu ritmo'
    },
    'values your interests': {
        en: 'values your interests',
        pt: 'valoriza seus interesses',
        es: 'valora tus intereses'
    },
    'and turns the process into something natural': {
        en: 'and turns the process into something natural',
        pt: 'e transforma o aprendizado em algo natural',
        es: 'y transforma el proceso en algo natural'
    },
    'instructors': {
        en: 'instructors',
        pt: 'instrutores',
        es: 'instructores'
    },
    'testimonies': {
        en: 'testimonies',
        pt: 'testemunhos',
        es: 'testimonios'
    },
    'blog': {
        en: 'blog',
        pt: 'blog',
        es: 'blog'
    },
    'logout': {
        en: 'logout',
        pt: 'sair',
        es: 'salir'
    },
    'email': {
        en: 'email',
        pt: 'e-mail',
        es: 'correo'
    },
    'students': {
        en: 'students',
        pt: 'alunos',
        es: 'alumnos'
    },
    'student payments': {
        en: 'student payments',
        pt: 'pagamentos de alunos',
        es: 'pagos de alumnos'
    },
    'every step counts, even the small ones!': {
        en: 'every step counts, even the small ones!',
        pt: 'cada passo conta, mesmo os menores!',
        es: 'cada paso cuenta, incluso los más pequeños!'
    },
    'a modern cultural platform blending language learning with creativity, lifestyle, and inspiring stories': {
        en: 'a modern cultural platform blending language learning with creativity, lifestyle, and inspiring stories',
        pt: 'uma plataforma cultural moderna que une o aprendizado de idiomas à criatividade, estilo de vida e histórias inspiradoras',
        es: 'una plataforma cultural moderna que une el aprendizaje de idiomas con la creatividad, el estilo de vida e historias inspiradoras'
    },
    'Mercado Pago has processed your payment. Your course will be available in your members area shortly.': {
        en: 'Mercado Pago has processed your payment. Your course will be available in your members area shortly.',
        pt: 'O Mercado Pago já identificou seu pagamento. Em breve, seu curso estará disponível na sua área de membros.',
        es: 'Mercado Pago ya ha identificado tu pago. Pronto, tu curso estará disponible en tu área de miembros.'
    },
    'VIEW RECEIPT': {
        en: 'VIEW RECEIPT',
        pt: 'VER COMPROVANTE',
        es: 'VER COMPROBANTE'
    },
    'Awaiting': {
        en: 'Awaiting payment',
        pt: 'Aguardando pagamento',
        es: 'Esperando el pago'
    },
    'Your order has been created and we are awaiting payment confirmation from Mercado Pago.': {
        en: 'Your order has been created and we are awaiting payment confirmation from Mercado Pago.',
        pt: 'Seu pedido foi gerado e estamos aguardando a confirmação do pagamento pelo Mercado Pago.',
        es: 'Tu pedido ha sido generado y estamos esperando la confirmación del pago por parte de Mercado Pago.'
    },
    'You can still complete your payment by clicking the button below:': {
        en: 'You can still complete your payment by clicking the button below:',
        pt: 'Você ainda pode realizar o pagamento clicando no botão abaixo:',
        es: 'Aún podes realizar el pago fazendo clic en el botón de abajo:'
    },
    'This payment link is no longer valid.': {
        en: 'This payment link is no longer valid.',
        pt: 'Este link de pagamento não é mais válido.',
        es: 'Este enlace de pago ya no es válido.'
    },
    'To proceed, you can generate a new payment link:': {
        en: 'To proceed, you can generate a new payment link:',
        pt: 'Para continuar, você pode gerar um novo link de pagamento:',
        es: 'Para continuar, puedes generar un nuevo enlace de pago:'
    },
    'PAY NOW': {
        en: 'PAY NOW',
        pt: 'PAGAR AGORA',
        es: 'PAGAR AHORA'
    },
    'RETRY PAYMENT': {
        en: 'RETRY PAYMENT',
        pt: 'REFAZER PAGAMENTO',
        es: 'REHACER PAGO'
    },
    'Payment expired': {
        en: 'Payment expired',
        pt: 'Pagamento expirado',
        es: 'Pago expirado'
    },
    'The time limit to complete this payment has run out.': {
        en: 'The time limit to complete this payment has run out.',
        pt: 'O tempo para realizar este pagamento acabou.',
        es: 'El tiempo para realizar este pago ha terminado.'
    },
    'We could not verify the payment within the required time limit.': {
        en: 'We could not verify the payment within the required time limit.',
        pt: 'Não foi possível identificar o pagamento dentro do prazo limite.',
        es: 'No fue posible identificar el pago dentro del plazo límite.'
    },
    "But don't worry! You can generate a new payment link right now:": {
        en: "But don't worry! You can generate a new payment link right now:",
        pt: 'Mas não se preocupe! Você pode gerar um novo link de pagamento agora mesmo:',
        es: '¡Pero no te preocupes! Puedes generar un nuevo enlace de pago ahora mismo:'
    },
    'GENERATE NEW LINK': {
        en: 'GENERATE NEW LINK',
        pt: 'GERAR NOVO LINK',
        es: 'GENERAR NUEVO ENLACE'
    },
    "a problem occurred with your application, reload the page or contact the suport": {
        en: "a problem occurred with your application, reload the page or contact the suport",
        pt: "ocorreu um problema com a sua aplicação, recarregue a página ou entre em contato com o suporte",
        es: "ocurrió un problema con su aplicación, recargue la página o contacte al soporte"
    },
    "Authentication expired": {
        en: "Authentication expired",
        pt: "Autenticação expirada",
        es: "Autenticación expirada"
    },
    "Login expired, please log in again.": {
        en: "Login expired, please log in again.",
        pt: "Sessão expirada, por favor faça login novamente.",
        es: "Sesión expirada, por favor inicie sesión de nuevo."
    },
    "login expired": {
        en: "login expired",
        break: "login expirado",
        pt: "login expirado",
        es: "login expirado"
    },
    "day(s)": {
        en: "day(s)",
        pt: "dia(s)",
        es: "día(s)"
    },
    "password is too shot, it must have more than 6 characters length": {
        en: "password is too shot, it must have more than 6 characters length",
        pt: "a senha é muito curta, ela deve ter mais de 6 caracteres",
        es: "la contraseña es demasiado corta, debe tener más de 6 caracteres de longitud"
    },
    "password is too long, it must have more than 20 characters length": {
        en: "password is too long, it must have more than 20 characters length",
        pt: "a senha é muito longa, ela deve ter no máximo 20 caracteres",
        es: "la contraseña es demasiado larga, debe tener menos de 20 caracteres de longitud"
    },
    "invalid password, enter a special character": {
        en: "invalid password, enter a special character",
        pt: "senha inválida, insira um caractere especial",
        es: "contraseña inválida, ingrese un carácter especial"
    },
    "invalid password, enter a number": {
        en: "invalid password, enter a number",
        pt: "senha inválida, insira um número",
        es: "contraseña inválida, ingrese un número"
    },
    "invalid password, enter an uppercase letter": {
        en: "invalid password, enter an uppercase letter",
        pt: "senha inválida, insira uma letra maiúscula",
        es: "contraseña inválida, ingrese una letra mayúscula"
    },
    "invalid password, enter a lowercase letter": {
        en: "invalid password, enter a lowercase letter",
        pt: "senha inválida, insira uma letra minúscula",
        es: "contraseña inválida, ingrese una letra minúscula"
    },
    "min read": {
        en: "min read",
        pt: "min de leitura",
        es: "min de lectura"
    },
    "about": {
        en: "about",
        pt: "sobre",
        es: "sobre / acerca de"
    },
    "navigation": {
        en: "navigation",
        pt: "navegação",
        es: "navegación"
    },
    "newsletter": {
        en: "newsletter",
        pt: "boletim informativo",
        es: "boletín informativo"
    },
    "Receive weekly articles, trends and inspiration.": {
        en: "Receive weekly articles, trends and inspiration.",
        pt: "Receba artigos semanais, tendências e inspiração.",
        es: "Reciba artículos semanales, tendencias e inspiración."
    },
    "join": {
        en: "join",
        pt: "participar / entrar",
        es: "unirse"
    },
    "privacy policy": {
        en: "privacy policy",
        pt: "política de privacidade",
        es: "política de privacidad"
    },
    "terms": {
        en: "terms",
        pt: "termos",
        es: "términos"
    },
    "no course found": {
        en: "no course found",
        pt: "nenhum curso encontrado",
        es: "no se encontró nenhum curso"
    },
    "what course do you seek?": {
        en: "what course do you seek?",
        pt: "qual curso você procura?",
        es: "¿qué curso buscas?"
    },
    "search": {
        en: "search",
        pt: "buscar",
        es: "buscar"
    },
    "read more": {
        en: "read more",
        pt: "ler mais",
        es: "leer más"
    },
    "your cart is empty.": {
        en: "your cart is empty.",
        pt: "seu carrinho está vazio.",
        es: "tu carrito está vacío."
    },
    "continue shopping": {
        en: "continue shopping",
        pt: "continuar comprando",
        es: "continuar comprando"
    },
    "total": {
        en: "total",
        pt: "total",
        es: "total"
    },
    "last updated at": {
        en: "last updated at",
        pt: "última atualização há",
        es: "última actualización hace"
    },
    "video in": {
        en: "video in",
        pt: "vídeo em",
        es: "video en"
    },
    "learn": {
        en: "learn",
        pt: "aprenda",
        es: "aprende"
    },
    "info": {
        en: "info",
        pt: "informações",
        es: "información"
    },
    "classes": {
        en: "classes",
        pt: "aulas",
        es: "clases"
    },
    "materials": {
        en: "materials",
        pt: "materiais",
        es: "materiales"
    },
    "lessons": {
        en: "lessons",
        pt: "lições",
        es: "lecciones"
    },
    "description": {
        en: "description",
        pt: "descrição",
        es: "descripción"
    },
    "instructor": {
        en: "instructor",
        pt: "instrutor",
        es: "instructor"
    },
    "No categories registered.": {
        en: "No categories registered.",
        pt: "Nenhuma categoria registrada.",
        es: "No hay categorías registradas."
    },
    "Course content:": {
        en: "Course content:",
        pt: "Conteúdo do curso:",
        es: "Contenido del curso:"
    },
    "name": {
        en: "name",
        pt: "nome",
        es: "nombre"
    },
    "duration": {
        en: "duration",
        pt: "duração",
        es: "duración"
    },
    "avaliations": {
        en: "avaliations",
        pt: "avaliações",
        es: "evaluaciones"
    },
    "sales": {
        en: "sales",
        pt: "vendas",
        es: "ventas"
    },
    "highest rating": {
        en: "highest rating",
        pt: "maior classificação",
        es: "calificación más alta"
    },
    "total hours": {
        en: "total hours",
        pt: "total de horas",
        es: "horas totales"
    },
    "hours": {
        en: "hours",
        pt: "horas",
        es: "horas"
    },
    "videos": {
        en: "videos",
        pt: "vídeos",
        es: "videos"
    },
    "clear all": {
        en: "clear all",
        pt: "limpar tudo",
        es: "limpiar todo"
    },
    "course level": {
        en: "course level",
        pt: "nível do curso",
        es: "nivel del curso"
    },
    "video removed": {
        en: "video removed",
        pt: "vídeo removido",
        es: "video eliminado"
    },
    "categories saved": {
        en: "categories saved",
        pt: "categorias salvas",
        es: "categorías guardadas"
    },
    "no language selected": {
        en: "no language selected",
        pt: "nenhum idioma selecionado",
        es: "ningún idioma seleccionado"
    },
    "select image": {
        en: "select image",
        pt: "selecionar imagem",
        es: "seleccionar imagen"
    },
    "course created": {
        en: "course created",
        pt: "curso criado",
        es: "curso creado"
    },
    "course updated": {
        en: "course atualizado",
        es: "curso actualizado"
    },
    "choose your language": {
        en: "choose your language",
        pt: "escolha o seu idioma",
        es: "elige tu idioma"
    },
    "translations": {
        en: "translations",
        pt: "traduções",
        es: "traducciones"
    },
    "logged out": {
        en: "logged out",
        pt: "sessão encerrada",
        es: "sesión cerrada"
    },
    "The best companies choose": {
        en: "The best companies choose",
        pt: "As melhores empresas escolhem",
        es: "Las mejores empresas eligen"
    },
    "community": {
        en: "community",
        pt: "comunidade",
        es: "comunidad"
    },
    "institutional": {
        en: "institutional",
        pt: "institucional",
        es: "institucional"
    },
    "Who we are": {
        en: "Who we are",
        pt: "Quem somos",
        es: "Quiénes somos"
    },
    "Work with us": {
        en: "Work with us",
        pt: "Trabalhe conosco",
        es: "Trabaja con nosotros"
    },
    "legal": {
        en: "legal",
        pt: "legal / termos jurídicos",
        es: "legal"
    },
    "privacy": {
        en: "privacy",
        pt: "privacidade",
        es: "privacidad"
    },
    "login": {
        en: "login",
        pt: "entrar / login",
        es: "iniciar sesión"
    },
    "subscribe": {
        en: "subscribe",
        pt: "inscrever-se",
        es: "suscribirse"
    },
    "sign in / login": {
        en: "sign in / login",
        pt: "entrar / fazer login",
        es: "iniciar sesión"
    },
    "profile picture": {
        en: "profile picture",
        pt: "foto de perfil",
        es: "foto de perfil"
    },
    "explore": {
        en: "explore",
        pt: "explorar",
        es: "explorar"
    },
    "hello": {
        en: "hello",
        pt: "olá",
        es: "hola"
    },
    "my profile": {
        en: "my profile",
        pt: "meu perfil",
        es: "mi perfil"
    },
    "search for anything": {
        en: "search for anything",
        pt: "pesquise por qualquer coisa",
        es: "buscar cualquier cosa"
    },
    "course not found": {
        en: "course not found",
        pt: "curso não encontrado",
        es: "curso no encontrado"
    },
    "no action avaliable": {
        en: "no action avaliable",
        pt: "nenhuma ação disponível",
        es: "ninguna acción disponible"
    },
    "cnpj": {
        en: "cnpj",
        pt: "CNPJ",
        es: "CNPJ"
    },
    "check out this": {
        en: "check out this",
        pt: "veja isso",
        es: "mira esto"
    },
    "link copied": {
        en: "link copied",
        pt: "link copiado",
        es: "enlace copiado"
    },
    "link not copied": {
        en: "link not copied",
        pt: "link não copiado",
        es: "enlace no copiado"
    },
    "Receipt for the order": {
        en: "Receipt for the order",
        pt: "Comprovante do pedido",
        es: "Comprobante del pedido"
    },
    "date": {
        en: "date",
        pt: "data",
        es: "fecha"
    },
    "Order No.": {
        en: "Order No.",
        pt: "Nº do Pedido",
        es: "Nro. de Pedido"
    },
    "Sold to": {
        en: "Sold to",
        pt: "Vendido para",
        es: "Vendido a"
    },
    "student": {
        en: "student",
        pt: "estudante / aluno",
        es: "estudiante / alumno"
    },
    "item": {
        en: "item",
        pt: "item",
        es: "artículo / ítem"
    },
    "purchase date": {
        en: "purchase date",
        pt: "data da compra",
        es: "fecha de compra"
    },
    "price": {
        en: "price",
        pt: "preço",
        es: "precio"
    },
    "total payed": {
        en: "total payed",
        pt: "total pago",
        es: "total pagado"
    },
    "this is an invoice generated automatically by the system": {
        en: "this is an invoice generated automatically by the system",
        pt: "este é um comprovante gerado automaticamente pelo sistema",
        es: "esta es una factura generada automáticamente por el sistema"
    },
    "invoice": {
        en: "invoice",
        pt: 'fatura',
        es: 'factura'
    },
    "Questions? Contact us.": {
        en: "Questions? Contact us.",
        pt: "Dúvidas? Entre em contato conosco.",
        es: "¿Preguntas? Contáctenos."
    },
    "choose a language": {
        en: "choose a language",
        pt: "escolha um idioma",
        es: "elija un idioma"
    },
    "cancel": {
        en: "cancel",
        pt: "cancelar",
        es: "cancelar"
    },
    "confirm": {
        en: "confirm",
        pt: "confirmar",
        es: "confirmar"
    },
    "select a language": {
        en: "select a language",
        pt: "selecione um idioma",
        es: "seleccione un idioma"
    },
    "loading": {
        en: "loading",
        pt: "carregando",
        es: "cargando"
    },
    "accepted formats are: JPEG, PNG and GIF": {
        en: "accepted formats are: JPEG, PNG and GIF",
        pt: "os formatos aceitos são: JPEG, PNG e GIF",
        es: "los formatos aceptados son: JPEG, PNG y GIF"
    },
    "max allowed size is 2 MB": {
        en: "max allowed size is 2 MB",
        pt: "o tamanho máximo permitido é 2 MB",
        es: "el tamaño máximo permitido es 2 MB"
    },
    "new update available. Do you want to reupload to the latest version?": {
        en: "new update available. Do you want to reupload to the latest version?",
        pt: "nova atualização disponível. Você deseja reenviar para a versão mais recente?",
        es: "nueva actualización disponible. ¿Desea volver a cargar a la última versión?"
    },
    "not authenticated": {
        en: "not authenticated",
        pt: "não autenticado",
        es: "no autenticado"
    },
    "manage about section (intructor profile)": {
        en: "manage about section (intructor profile)",
        pt: "gerenciar seção sobre (perfil do instrutor)",
        es: "gestionar sección sobre (perfil del instructor)"
    },
    "canceled": {
        en: "canceled",
        pt: "cancelado",
        es: "cancelado"
    },
    "no calling found": {
        en: "no calling found",
        pt: "nenhum chamado encontrado",
        es: "no se encontraron tickets"
    },
    "title": {
        en: "title",
        pt: "título",
        es: "título"
    },
    "motive": {
        en: "motive",
        pt: "motivo",
        es: "motivo"
    },
    "course": {
        en: "course",
        pt: "curso",
        es: "curso"
    },
    "open at": {
        en: "open at",
        pt: "aberto em",
        es: "abierto el"
    },
    "actions": {
        en: "actions",
        pt: "ações",
        es: "acciones"
    },
    "see details": {
        en: "see details",
        pt: "ver detalhes",
        es: "ver detalles"
    },
    "close calling": {
        en: "close calling",
        pt: "fechar chamado",
        es: "cerrar ticket"
    },
    "open new calling": {
        en: "open new calling",
        pt: "abrir novo chamado",
        es: "abrir nuevo ticket"
    },
    "title of calling": {
        en: "title of calling",
        pt: "título do chamado",
        es: "título del ticket"
    },
    "describe the problem": {
        en: "describe the problem",
        pt: "descreva o problema",
        es: "describa el problema"
    },
    "post removed": {
        en: "post removed",
        pt: "postagem removida",
        es: "publicación eliminada"
    },
    "post saved": {
        en: "post saved",
        pt: "postagem salva",
        es: "publicación guardada"
    },
    "no category found": {
        en: "no category found",
        pt: "nenhuma categoria encontrada",
        es: "no se encontró ninguna categoría"
    },
    "Invalid file type": {
        en: "Invalid file type",
        pt: "Tipo de arquivo inválido",
        es: "Tipo de archivo no válido"
    },
    "invalid file size, file size should be smaller than 1MB": {
        en: "invalid file size, file size should be smaller than 1MB",
        pt: "tamanho de arquivo inválido, o arquivo deve ser menor que 1MB",
        es: "tamaño de archivo no válido, el archivo debe ser menor a 1MB"
    },
    "invalid file": {
        en: "invalid file",
        pt: "arquivo inválido",
        es: "archivo no válido"
    },
    "at least the name is required": {
        en: "at least the name is required",
        pt: "pelo menos o nome é obrigatório",
        es: "al menos el nombre es obligatorio"
    },
    "instructor saved with success": {
        en: "instructor saved with success",
        pt: "instrutor salvo com sucesso",
        es: "instructor guardado con éxito"
    },
    "the name is required": {
        en: "the name is required",
        pt: "o nome é obrigatório",
        es: "el nombre es obligatorio"
    },
    "student saved": {
        en: "student saved",
        pt: "aluno salvo",
        es: "alumno guardado"
    },
    "all the names and content must be filled": {
        en: "all the names and content must be filled",
        pt: "todos os nomes e conteúdos devem ser preenchidos",
        es: "todos los nombres y contenidos deben ser completados"
    },
    "testimonies saved with success": {
        en: "testimonies saved with success",
        pt: "depoimentos salvos com sucesso",
        es: "testimonios guardados con éxito"
    },
    "Explore exclusive content about education, technology, and the natural learning process.": {
        en: "Explore exclusive content about education, technology, and the natural learning process.",
        pt: "Explore conteúdos exclusivos sobre educação, tecnologia e o processo natural de aprendizagem.",
        es: "Explore contenido exclusivo sobre educación, tecnología y el proceso de aprendizaje natural."
    },
    "No articles published yet.": {
        en: "No articles published yet.",
        pt: "Nenhum artigo publicado ainda.",
        es: "Aún no se han publicado artículos."
    },
    "No posts found.": {
        en: "No posts found.",
        pt: "Nenhuma postagem encontrada.",
        es: "No se encontraron publicaciones."
    },
    "read article": {
        en: "read article",
        pt: "ler artigo",
        es: "leer artículo"
    },
    "author": {
        en: "author",
        pt: "autor",
        es: "autor"
    },
    "Back to Blog": {
        en: "Back to Blog",
        pt: "Voltar ao Blog",
        es: "Volver al Blog"
    },
    "Copy Link": {
        en: "Copy Link",
        pt: "Copiar Link",
        es: "Copiar enlace"
    },
    "post not found": {
        en: "post not found",
        pt: "postagem não encontrada",
        es: "publicación no encontrada"
    },
    "The article you are trying to access does not exist anymore.": {
        en: "The article you are trying to access does not exist anymore.",
        pt: "O artigo que você está tentando acessar não existe mais.",
        es: "El artículo al que intenta acceder ya no existe."
    },
    "Back To Blog": {
        en: "Back To Blog",
        pt: "Voltar ao Blog",
        es: "Volver al Blog"
    },
    "Link copied successfully!": {
        en: "Link copied successfully!",
        pt: "Link copiado com sucesso!",
        es: "¡Enlace copiado con éxito!"
    },
    "Certificate Pending": {
        en: "Certificate Pending",
        pt: "Certificado Pendente",
        es: "Certificado Pendiente"
    },
    "The certificate above attests that": {
        en: "The certificate above attests that",
        pt: "O certificado acima atesta que",
        es: "El certificado de arriba da fe de que"
    },
    "successfully completed the course": {
        en: "successfully completed the course",
        pt: "concluiu o curso com sucesso",
        es: "completó con éxito el curso"
    },
    "at": {
        en: "at",
        pt: "em",
        es: "en"
    },
    "taught by": {
        en: "taught by",
        pt: "ministrado por",
        es: "dictado por"
    },
    "The certificate indicates that the entire course has been completed, as validated by the student.": {
        en: "The certificate indicates that the entire course has been completed, as validated by the student.",
        pt: "O certificado indica que todo o curso foi concluído, conforme validado pelo aluno.",
        es: "El certificado indica que se ha completado todo el curso, según lo validado por el estudiante."
    },
    "The course duration represents the total hours of video and article lectures at the time of the most recent completion.": {
        en: "The course duration represents the total hours of video and article lectures at the time of the most recent completion.",
        pt: "A duração do curso representa o total de horas de aulas em vídeo e artigos no momento da conclusão mais recente.",
        es: "La duración del curso representa el total de horas de clases en video y artículos en el momento de la finalización más reciente."
    },
    "Your certificate does not yet exist or is in the process of being generated. Please wait a few hours while we generate your certificate.": {
        en: "Your certificate does not yet exist or is in the process of being generated. Please wait a few hours while we generate your certificate.",
        pt: "Seu certificado ainda não existe ou está em processo de geração. Por favor, aguarde algumas horas enquanto geramos seu certificado.",
        es: "Su certificado aún no existe o está en proceso de generación. Por favor, espere unas horas mientras generamos su certificado."
    },
    "Recipient of the certificate:": {
        en: "Recipient of the certificate:",
        pt: "Destinatário do certificado:",
        es: "Destinatario del certificado:"
    },
    "About the course:": {
        en: "About the course:",
        pt: "Sobre o curso:",
        es: "Acerca del curso:"
    },
    "download": {
        en: "download",
        pt: "baixar / download",
        es: "descargar"
    },
    "share": {
        en: "share",
        pt: "compartilhar",
        es: "compartir"
    },
    "update name on certificate": {
        en: "update name on certificate",
        pt: "atualizar nome no certificado",
        es: "actualizar nombre en el certificado"
    },
    "share this course": {
        en: "share this course",
        pt: "compartilhar este curso",
        es: "compartir este curso"
    },
    "change certificate name": {
        en: "change certificate name",
        pt: "alterar nome do certificado",
        es: "cambiar nombre del certificado"
    },
    "if you confirm the new name change request, your certificate will be unavaliable for some minutes": {
        en: "if you confirm the new name change request, your certificate will be unavaliable for some minutes",
        pt: "se você confirmar o pedido de alteração de nome, seu certificado ficará indisponível por alguns minutos",
        es: "si confirma la solicitud de cambio de nombre, su certificado no estará disponible durante unos minutos"
    },
    "certificate not found": {
        en: "certificate not found",
        pt: "certificado não encontrado",
        es: "certificado no encontrado"
    },
    "course information not found": {
        en: "course information not found",
        pt: "informações do curso não encontradas",
        es: "información del curso no encontrada"
    },
    "selected certificate format not avaliable": {
        en: "selected certificate format not avaliable",
        pt: "formato de certificado selecionado não disponível",
        es: "formato de certificado seleccionado no disponible"
    },
    "a name is required": {
        en: "a name is required",
        pt: "um nome é obrigatório",
        es: "se requiere un nombre"
    },
    "the name must be different": {
        en: "the name must be different",
        pt: "o nome deve ser diferente",
        es: "el nombre debe ser diferente"
    },
    "a problem occurred, try again later": {
        en: "a problem occurred, try again later",
        pt: "ocorreu um problema, tente novamente mais tarde",
        es: "ocurrió un problema, inténtelo de nuevo más tarde"
    },
    "certificate name changed": {
        en: "certificate name changed",
        pt: "nome do certificado alterado",
        es: "nombre del certificado cambiado"
    },
    "you have already changed the name recently, please wait some time before requesting another change": {
        en: "you have already changed the name recently, please wait some time before requesting another change",
        pt: "você já alterou o nome recentemente, por favor aguarde um tempo antes de solicitar outra alteração",
        es: "ya ha cambiado el nombre recientemente, por favor espere un tiempo antes de solicitar otro cambio"
    },
    "you must wait": {
        en: "you must wait",
        pt: "você deve aguardar",
        es: "debe esperar"
    },
    "certificate of completion": {
        en: "certificate of completion",
        pt: "certificado de conclusão",
        es: "certificado de finalización"
    },
    "Check out the Course:": {
        en: "Check out the Course:",
        pt: "Confira o Curso:",
        es: "Mira el Curso:"
    },
    "What will you find?": {
        en: "What will you find?",
        pt: "O que você vai encontrar?",
        es: "¿Qué vas a encontrar?"
    },
    "Share with your friends and come learn together!": {
        en: "Share with your friends and come learn together!",
        pt: "Compartilhe com seus amigos e venham aprender juntos!",
        es: "¡Comparte con tus amigos y vengan a aprender juntos!"
    },
    "Find out more at:": {
        en: "Find out more at:",
        pt: "Saiba mais em:",
        es: "Descubre más en:"
    },
    "resourses": {
        en: "resourses",
        pt: "recursos",
        es: "recursos"
    },
    "no support material": {
        en: "no support material",
        pt: "nenhum material de apoio",
        es: "sin material de apoyo"
    },
    "download file": {
        en: "download file",
        pt: "baixar arquivo",
        es: "descargar archivo"
    },
    "no answer avaliables": {
        en: "no answer avaliables",
        pt: "nenhuma resposta disponível",
        es: "no hay respuestas disponibles"
    },
    "choose one of the options below": {
        en: "choose one of the options below",
        pt: "escolha uma das opções abaixo",
        es: "elija una de las opciones a continuación"
    },
    "write your answer below": {
        en: "write your answer below",
        pt: "escreva sua resposta abaixo",
        es: "escriba su respuesta a continuación"
    },
    "result": {
        en: "result",
        pt: "resultado",
        es: "resultado"
    },
    "answer": {
        en: "answer",
        pt: "resposta",
        es: "respuesta"
    },
    "justification": {
        en: "justification",
        pt: "justificativa",
        es: "justificación"
    },
    "send answer": {
        en: "send answer",
        pt: "enviar resposta",
        es: "enviar respuesta"
    },
    "get course certificate": {
        en: "get course certificate",
        pt: "obter certificado do curso",
        es: "obtener certificado del curso"
    },
    "your progress": {
        en: "your progress",
        pt: "seu progresso",
        es: "tu progreso"
    },
    "completed": {
        en: "completed",
        pt: "concluído",
        es: "completado"
    },
    "complete the course to obtain your certificate": {
        en: "complete the course to obtain your certificate",
        pt: "conclua o curso para obter seu certificado",
        es: "completa el curso para obtener tu certificado"
    },
    "get certificate": {
        en: "get certificate",
        pt: "obter certificado",
        es: "obtener certificado"
    },
    "automatic": {
        en: "automatic",
        pt: "automático",
        es: "automático"
    },
    "no video selected": {
        en: "no video selected",
        pt: "nenhum vídeo selecionado",
        es: "ningún video seleccionado"
    },
    "lesson": {
        en: "lesson",
        pt: "lição / aula",
        es: "lección / clase"
    },
    "no video found": {
        en: "no video found",
        pt: "nenhum vídeo encontrado",
        es: "no se encontró ningún video"
    },
    "quality defined to: Automatic": {
        en: "quality defined to: Automatic",
        pt: "qualidade definida para: Automático",
        es: "calidad definida en: Automático"
    },
    "invalid quality": {
        en: "invalid quality",
        pt: "qualidade inválida",
        es: "calidad no válida"
    },
    "not specified": {
        en: "not specified",
        pt: "não especificado",
        es: "no especificado"
    },
    "check this course": {
        en: "check this course",
        pt: "confira este curso",
        es: "mira este curso"
    },
    "what will you find?": {
        en: "what will you find?",
        pt: "o que você vai encontrar?",
        es: "¿qué vas a encontrar?"
    },
    "share with your friends and come learn together!": {
        en: "share with your friends and come learn together!",
        pt: "compartilhe com seus amigos e venham aprender juntos!",
        es: "¡comparte con tus amigos y vengan a aprender juntos!"
    },
    "find out more at": {
        en: "find out more at",
        pt: "saiba mais em",
        es: "descubre más en"
    },
    "a problemn occured, try again later or contact the suport": {
        en: "a problemn occured, try again later or contact the suport",
        pt: "ocorreu um problema, tente novamente mais tarde ou entre em contato com o suporte",
        es: "ocurrió un problema, inténtelo más tarde o contacte al soporte"
    },
    "you don't have any courses yet!": {
        en: "you don't have any courses yet!",
        pt: "você ainda não possui nenhum curso!",
        es: "¡todavía no tienes ningún curso!"
    },
    "filter by": {
        en: "filter by",
        pt: "filtrar por",
        es: "filtrar por"
    },
    "course title": {
        en: "course title",
        pt: "título do curso",
        es: "título del curso"
    },
    "search menus": {
        en: "search menus",
        pt: "menus de busca",
        es: "menús de búsqueda"
    },
    "my performance": {
        en: "my performance",
        pt: "meu desempenho",
        es: "mi rendimiento"
    },
    "both": {
        en: "both",
        pt: "ambos",
        es: "ambos"
    },
    "in progress": {
        en: "in progress",
        pt: "em andamento",
        es: "en curso"
    },
    "Completed": {
        en: "Completed",
        pt: "Concluído",
        es: "Completado"
    },
    "a problem occurred": {
        en: "a problem occurred",
        pt: "ocorreu um problema",
        es: "ocurrió un problema"
    },
    "buying history": {
        en: "buying history",
        pt: "histórico de compras",
        es: "historial de compras"
    },
    "purchased items": {
        en: "purchased items",
        pt: "itens comprados",
        es: "artículos comprados"
    },
    "total price": {
        en: "total price",
        pt: "preço total",
        es: "precio total"
    },
    "payment type": {
        en: "payment type",
        pt: "tipo de pagamento",
        es: "tipo de pago"
    },
    "receipt": {
        en: "receipt",
        pt: "recibo",
        es: "recibo"
    },
    "no purchases found": {
        en: "no purchases found",
        pt: "nenhuma compra encontrada",
        es: "no se encontraron compras"
    },
    "unavailable": {
        en: "unavailable",
        pt: "indisponível",
        es: "no disponible"
    },
    "Account successfully created. You will be redirected shortly.": {
        en: "Account successfully created. You will be redirected shortly.",
        pt: "Conta criada com sucesso. Você será redirecionado em breve.",
        es: "Cuenta creada con éxito. Será redirigido en breve."
    },
    "results for": {
        en: "results for",
        pt: "resultados para",
        es: "resultados para"
    },
    "result found": {
        en: "result found",
        pt: "resultado encontrado",
        es: "resultado encontrado"
    },
    "results found": {
        en: "results found",
        pt: "resultados encontrados",
        es: "resultados encontrados"
    },
    "Still not sure? All courses include a certificate of completion.": {
        en: "Still not sure? All courses include a certificate of completion.",
        pt: "Ainda não tem certeza? Todos os cursos incluem um certificado de conclusão.",
        es: "¿Aún não estás seguro? Todos los cursos incluyen un certificado de finalización."
    },
    "filters": {
        en: "filters",
        pt: "filtros",
        es: "filtros"
    },
    "Sort by:": {
        en: "Sort by:",
        pt: "Ordenar por:",
        es: "Ordenar por:"
    },
    "select": {
        en: "select",
        pt: "selecionar",
        es: "seleccionar"
    },
    "No courses matched the search criteria.": {
        en: "No courses matched the search criteria.",
        pt: "Nenhum curso correspondeu aos critérios de busca.",
        es: "Ningún curso coincidió con los criterios de búsqueda."
    },
    'all courses': {
        en: "all courses",
        pt: "todos os cursos",
        es: "todos los cursos"
    },
    'most relevant': {
        en: "most relevant",
        pt: "mais relevante",
        es: "más relevante"
    },
    'newest': {
        en: "newest",
        pt: "mais novo",
        es: "más nuevo"
    },
    'cheaper': {
        en: "cheaper",
        pt: "mais barato",
        es: "mas barato"
    },
    'most expensive': {
        en: "most expensive",
        pt: "mais caro",
        es: "mas caro"
    },
    'Not logged in': {
        en: "Not logged in",
        pt: "Não entrou na conta",
        es: "No ingresó la cuenta"
    },
    '1-year access': {
        en: "1-year access",
        pt: "1 ano de acesso",
        es: "1 año de acceso"
    },
    'of video lessons': {
        en: "of video lessons",
        pt: "de video aulas",
        es: "de lecciones en video"
    },
    'available resources': {
        en: "available resources",
        pt: "recursos disponíveis",
        es: "recursos disponibles"
    },
    'Watch on your mobile phone or computer': {
        en: "Watch on your mobile phone or computer",
        pt: "Assista no seu celular ou computador",
        es: "Míralo en tu teléfono móvil o computadora"
    },
    'Order details': {
        en: "Order details",
        pt: "Detalhes do pedido",
        es: "Detalles del pedido"
    },
    'order summary': {
        en: "order summary",
        pt: "resumo do pedido",
        es: "resumen del pedido"
    },
    'By completing your purchase, you agree to these terms and conditions.': {
        en: "By completing your purchase, you agree to these terms and conditions.",
        pt: "Ao concluir sua compra, você concorda com estes termos e condições.",
        es: "Al completar su compra, usted acepta estos términos y condiciones."
    },
    'terms of use': {
        en: "terms of use",
        pt: "termos de uso",
        es: "condiciones de uso"
    },
    'By clicking the button above, a payment link will be generated and you will be redirected.': {
        en: "By clicking the button above, a payment link will be generated and you will be redirected.",
        pt: "Ao clicar no botão acima, um link de pagamento será gerado e você será redirecionado.",
        es: "Al hacer clic en el botón de arriba, se generará un enlace de pago y se le redirigirá."
    },
    'You already have a payment link for this/these course(s).': {
        en: "You already have a payment link for this/these course(s).",
        pt: "Você já possui um link de pagamento para este(s) curso(s).",
        es: "Ya tienes un enlace de pago para este/estos curso(s)."
    },
    'generate payment link': {
        en: "generate payment link",
        pt: "gerar link de pagamento",
        es: "generar enlace de pago"
    },
    'view pending payments': {
        en: "view pending payments",
        pt: "ver pagamentos pendentes",
        es: "ver pagos pendientes"
    },
    'access payment link': {
        en: "access payment link",
        pt: "acessar link de pagamento",
        es: "acceder al enlace de pago"
    },
    'contact support': {
        en: 'contact support',
        pt: "entre em contato com o suporte",
        es: "póngase en contacto con el soporte"
    },
    'No items selected for purchase.': {
        en: 'No items selected for purchase.',
        pt: "Nenhum item selecionado para compra.",
        es: "No se ha seleccionado ningún artículo para su compra."
    },
    'Log in to your account to continue': {
        en: 'Log in to your account to continue',
        pt: "Faça login na sua conta para continuar",
        es: "Inicia sesión en tu cuenta para continuar"
    },
    'Are you sure you want to proceed?': {
        en: 'Are you sure you want to proceed?',
        pt: "Tem certeza de que deseja prosseguir?",
        es: "¿Está seguro de que desea continuar?"
    },
    'If so, you will be redirected to our partner Mercado Pago where you can complete your purchase.': {
        en: 'If so, you will be redirected to our partner Mercado Pago where you can complete your purchase.',
        pt: "Nesse caso, você será redirecionado para o nosso parceiro Mercado Pago, onde poderá concluir sua compra.",
        es: "En ese caso, serás redirigido a nuestro socio Mercado Pago, donde podrás completar tu compra."
    },
    "We are undergoing maintenance, but don't worry, the site will be available soon": {
        en: "We are undergoing maintenance, but don't worry, the site will be available soon",
        pt: 'Estamos em manutenção, mas não se preocupe, o site estará disponível em breve',
        es: 'Estamos realizando tareas de mantenimiento, pero no se preocupe, el sitio estará disponible pronto'
    },
    "The page you are looking for could not be found!": {
        en: "The page you are looking for could not be found!",
        pt: 'A página que você está procurando não foi encontrada!',
        es: '¡La página que buscas no se ha podido encontrar!'
    },
    "We apologize for the inconvenience, but the page you were looking for does not exist in our system. Below are some useful links:": {
        en: "We apologize for the inconvenience, but the page you were looking for does not exist in our system. Below are some useful links:",
        pt: 'Pedimos desculpas pelo inconveniente, mas a página que você estava procurando não existe em nosso sistema. Abaixo estão alguns links úteis:',
        es: 'Lamentamos las molestias, pero la página que buscaba no existe en nuestro sistema. A continuación, encontrará algunos enlaces útiles:'
    },
    "Terms of Use": {
        "en": "Terms of Use",
        "pt": "Termos de Uso",
        "es": "Términos de Uso"
    },
    "Privacy Policy": {
        "en": "Privacy Policy",
        "pt": "Política de Privacidade",
        "es": "Política de Privacidad"
    },
    "Last updated": {
        "en": "Last updated",
        "pt": "Última atualização",
        "es": "Última actualización"
    },
    "Contact us": {
        "en": "Contact us",
        "pt": "Entre em contato",
        "es": "Contáctenos"
    },
    "Welcome to the": {
        "en": "Welcome to the",
        "pt": "Bem-vindo(a) à plataforma",
        "es": "Bienvenido(a) a la plataforma"
    },
    "platform. By registering, accessing, or using any feature of this platform, you declare that you have read, understood, and agree to these Terms of Use. If you do not agree with any of the conditions, please do not use the platform.": {
        "en": "platform. By registering, accessing, or using any feature of this platform, you declare that you have read, understood, and agree to these Terms of Use. If you do not agree with any of the conditions, please do not use the platform.",
        "pt": ". Ao se cadastrar, acessar ou utilizar qualquer funcionalidade desta plataforma, você declara que leu, entendeu e concorda com os presentes Termos de Uso. Caso não concorde com alguma das condições, pedimos que não utilize a plataforma.",
        "es": ". Al registrarse, acceder o utilizar cualquier función de esta plataforma, usted declara que ha leído, entendido y acepta estos Términos de Uso. Si no está de acuerdo, por favor no utilice la plataforma."
    },
    "Online courses": {
        "en": "Online courses",
        "pt": "Cursos online",
        "es": "Cursos en línea"
    },
    "Purchase and access recorded English courses, available at any time.": {
        "en": "Purchase and access recorded English courses, available at any time.",
        "pt": "Venda e acesso a cursos gravados de inglês, disponíveis a qualquer momento.",
        "es": "Compra y acceso a cursos grabados de inglés, disponibles en cualquier momento."
    },
    "Watch your purchased content directly on the platform, at your own pace.": {
        "en": "Watch your purchased content directly on the platform, at your own pace.",
        "pt": "Assista aos conteúdos adquiridos diretamente na plataforma, no seu ritmo.",
        "es": "Mira tu contenido comprado directamente en la plataforma, a tu propio ritmo."
    },
    "Private lessons": {
        "en": "Private lessons",
        "pt": "Aulas particulares",
        "es": "Clases particulares"
    },
    "Exclusive materials and personalized pedagogical support.": {
        "en": "Exclusive materials and personalized pedagogical support.",
        "pt": "Sessões, materiais exclusivos e acompanhamento pedagógico individualizado.",
        "es": "Materiales exclusivos y apoyo pedagógico personalizado."
    },
    "Account registration": {
        "en": "Account registration",
        "pt": "Cadastro e conta",
        "es": "Registro y cuenta"
    },
    "To access the services, you must create an account with email and password. You are responsible for:": {
        "en": "To access the services, you must create an account with email and password. You are responsible for:",
        "pt": "Para acessar os serviços, é necessário criar uma conta com e-mail e senha. Você é responsável por:",
        "es": "Para acceder a los servicios, debe crear una cuenta con email y contraseña. Usted es responsable de:"
    },
    "Keeping your login credentials confidential.": {
        "en": "Keeping your login credentials confidential.",
        "pt": "Manter a confidencialidade de suas credenciais de acesso.",
        "es": "Mantener la confidencialidad de sus credenciales de acceso."
    },
    "All activities performed on your account.": {
        "en": "All activities performed on your account.",
        "pt": "Todas as atividades realizadas em sua conta.",
        "es": "Todas las actividades realizadas en su cuenta."
    },
    "Immediately notifying any unauthorized use.": {
        "en": "Immediately notifying any unauthorized use.",
        "pt": "Notificar imediatamente qualquer uso não autorizado.",
        "es": "Notificar inmediatamente cualquier uso no autorizado."
    },
    "Access is personal and non-transferable. The platform uses a": {
        "en": "Access is personal and non-transferable. The platform uses a",
        "pt": "O acesso é pessoal e intransferível. A plataforma utiliza um sistema de",
        "es": "El acceso es personal e intransferible. La plataforma utiliza un sistema de"
    },
    "single active session": {
        "en": "single active session",
        "pt": "sessão única ativa",
        "es": "sesión única activa"
    },
    ": a new login on another device will automatically end the previous session.": {
        "en": ": a new login on another device will automatically end the previous session.",
        "pt": ": um novo login em outro dispositivo encerrará automaticamente a sessão anterior.",
        "es": ": un nuevo inicio de sesión en otro dispositivo cerrará automáticamente la sesión anterior."
    },
    "Course purchase": {
        "en": "Course purchase",
        "pt": "Aquisição de cursos",
        "es": "Adquisición de cursos"
    },
    "Course purchases require advance payment at the prices displayed on the platform at the time of purchase. After payment confirmation, course access is granted immediately.": {
        "en": "Course purchases require advance payment at the prices displayed on the platform at the time of purchase. After payment confirmation, course access is granted immediately.",
        "pt": "A compra de cursos é realizada mediante pagamento prévio pelos valores exibidos na plataforma no momento da aquisição. Após a confirmação do pagamento, o acesso ao curso é liberado imediatamente.",
        "es": "La compra de cursos requiere pago anticipado a los precios mostrados en la plataforma en el momento de la compra. Tras la confirmación del pago, el acceso al curso se otorga de inmediato."
    },
    "Access to purchased content is": {
        "en": "Access to purchased content is",
        "pt": "O acesso ao conteúdo adquirido é",
        "es": "El acceso al contenido comprado es"
    },
    "temporary": {
        "en": "temporary",
        "pt": "temporário",
        "es": "temporal"
    },
    "and set to exactly 1 year (12 months) after purchase.": {
        "en": "and set to exactly 1 year (12 months) after purchase.",
        "pt": "e pré definido para exatamente 1 ano (12 mêses) após a compra.",
        "es": "y establecido en exactamente 1 año (12 meses) después de la compra."
    },
    "Refund policy": {
        "en": "Refund policy",
        "pt": "Política de reembolso",
        "es": "Política de reembolso"
    },
    "Right of withdrawal - 7 days": {
        "en": "Right of withdrawal - 7 days",
        "pt": "Direito de arrependimento - 7 dias",
        "es": "Derecho de desistimiento - 7 días"
    },
    "Under the": {
        "en": "Under the",
        "pt": "Nos termos do",
        "es": "De conformidad con el"
    },
    "Consumer Protection Code (Art. 49, Law No. 8,078/1990)": {
        "en": "Consumer Protection Code (Art. 49, Law No. 8,078/1990)",
        "pt": "Código de Defesa do Consumidor (Art. 49 da Lei nº 8.078/1990)",
        "es": "Código de Defensa del Consumidor (Art. 49, Ley N.º 8.078/1990)"
    },
    "you have the right to cancel and receive a full refund within": {
        "en": "you have the right to cancel and receive a full refund within",
        "pt": "você tem direito ao cancelamento e reembolso integral em até",
        "es": "tiene derecho a cancelar y recibir un reembolso completo dentro de"
    },
    "7 (seven) calendar days": {
        "en": "7 (seven) calendar days",
        "pt": "7 (sete) dias corridos",
        "es": "7 (siete) días corridos"
    },
    "from the purchase date, provided you have not accessed more than 20% of the course content.": {
        "en": "from the purchase date, provided you have not accessed more than 20% of the course content.",
        "pt": "a partir da data da compra, desde que não tenha acessado mais de 20% do conteúdo do curso.",
        "es": "desde la fecha de compra, siempre que no haya accedido a más del 20% del contenido del curso."
    },
    "To request a refund, contact us by email:": {
        "en": "To request a refund, contact us by email:",
        "pt": "Para solicitar reembolso, entre em contato pelo e-mail:",
        "es": "Para solicitar un reembolso, contáctenos por correo electrónico:"
    },
    "The student area allows access to exclusive materials provided by the teacher. Specific conditions (frequency, duration, and pricing) are defined in an individual contract between the student and the teacher.": {
        "en": "The student area allows access to exclusive materials provided by the teacher. Specific conditions (frequency, duration, and pricing) are defined in an individual contract between the student and the teacher.",
        "pt": "A área do aluno particular permite o acesso a materiais exclusivos disponibilizados pela professora. As condições específicas (frequência, duração e valores) são definidas em contrato individual entre o(a) aluno(a) e a professora.",
        "es": "El área del alumno permite el acceso a materiales exclusivos proporcionados por la profesora. Las condiciones específicas (frecuencia, duración y precios) se definen en un contrato individual entre el alumno y la profesora."
    },
    "Intellectual property": {
        "en": "Intellectual property",
        "pt": "Propriedade intelectual",
        "es": "Propiedad intelectual"
    },
    "All platform content - videos, texts, images, teaching materials, and class resources - is the exclusive property of": {
        "en": "All platform content - videos, texts, images, teaching materials, and class resources - is the exclusive property of",
        "pt": "Todo o conteúdo da plataforma - vídeos, textos, imagens, materiais pedagógicos e recursos de aula - é de propriedade exclusiva da",
        "es": "Todo el contenido de la plataforma - videos, textos, imágenes, materiales pedagógicos y recursos de clase - es propiedad exclusiva de"
    },
    "Escola de Idiomas Teacher Maestra Victoria": {
        "en": "Escola de Idiomas Teacher Maestra Victoria",
        "pt": "Escola de Idiomas Teacher Maestra Victoria",
        "es": "Escola de Idiomas Teacher Maestra Victoria"
    },
    "The following are strictly prohibited:": {
        "en": "The following are strictly prohibited:",
        "pt": "É expressamente proibido:",
        "es": "Está expresamente prohibido:"
    },
    "Reproducing, copying, redistributing, or sharing any content without prior written authorization.": {
        "en": "Reproducing, copying, redistributing, or sharing any content without prior written authorization.",
        "pt": "Reproduzir, copiar, redistribuir ou compartilhar qualquer conteúdo sem autorização prévia e escrita.",
        "es": "Reproducir, copiar, redistribuir o compartir cualquier contenido sin autorización previa y por escrito."
    },
    "Downloading or recording videos.": {
        "en": "Downloading or recording videos.",
        "pt": "Fazer download ou gravação dos vídeos.",
        "es": "Descargar o grabar los videos."
    },
    "Using materials for commercial purposes or teaching third parties.": {
        "en": "Using materials for commercial purposes or teaching third parties.",
        "pt": "Utilizar os materiais para fins comerciais ou ensino de terceiros.",
        "es": "Utilizar los materiales con fines comerciales o para enseñar a terceros."
    },
    "Removing watermarks, credits, or any authorship identification.": {
        "en": "Removing watermarks, credits, or any authorship identification.",
        "pt": "Remover marcas d'água, créditos ou qualquer identificação de autoria.",
        "es": "Eliminar marcas de agua, créditos o cualquier identificación de autoría."
    },
    "Copyright infringement may result in civil and criminal liability under Law No. 9,610/1998.": {
        "en": "Copyright infringement may result in civil and criminal liability under Law No. 9,610/1998.",
        "pt": "A violação de direitos autorais poderá ensejar responsabilização civil e criminal nos termos da Lei nº 9.610/1998.",
        "es": "La infracción de derechos de autor puede derivar en responsabilidad civil y penal según la Ley N.º 9.610/1998."
    },
    "User conduct": {
        "en": "User conduct",
        "pt": "Conduta do usuário",
        "es": "Conducta del usuario"
    },
    "By using the platform, you agree not to:": {
        "en": "By using the platform, you agree not to:",
        "pt": "Ao utilizar a plataforma, você concorda em não:",
        "es": "Al utilizar la plataforma, usted acepta no:"
    },
    "Share offensive, discriminatory, or illegal content.": {
        "en": "Share offensive, discriminatory, or illegal content.",
        "pt": "Compartilhar conteúdo ofensivo, discriminatório ou ilegal.",
        "es": "Compartir contenido ofensivo, discriminatorio o ilegal."
    },
    "Attempt to access restricted areas or compromise platform security.": {
        "en": "Attempt to access restricted areas or compromise platform security.",
        "pt": "Tentar acessar áreas restritas ou comprometer a segurança da plataforma.",
        "es": "Intentar acceder a áreas restringidas o comprometer la seguridad de la plataforma."
    },
    "Use automated tools for content extraction.": {
        "en": "Use automated tools for content extraction.",
        "pt": "Utilizar ferramentas automatizadas para extração de conteúdo.",
        "es": "Utilizar herramientas automatizadas para la extracción de contenido."
    },
    "Engage in any act that may harm other users or platform operations.": {
        "en": "Engage in any act that may harm other users or platform operations.",
        "pt": "Praticar qualquer ato que possa prejudicar outros usuários ou a operação da plataforma.",
        "es": "Realizar cualquier acto que pueda perjudicar a otros usuarios o las operaciones de la plataforma."
    },
    "Account suspension and termination": {
        "en": "Account suspension and termination",
        "pt": "Suspensão e encerramento de conta",
        "es": "Suspensión y cancelación de cuenta"
    },
    "We reserve the right to suspend or terminate your account, without prior notice, in case of:": {
        "en": "We reserve the right to suspend or terminate your account, without prior notice, in case of:",
        "pt": "Reservamo-nos o direito de suspender ou encerrar sua conta, sem aviso prévio, em caso de:",
        "es": "Nos reservamos el derecho de suspender o cancelar su cuenta, sin previo aviso, en caso de:"
    },
    "Violation of these Terms of Use.": {
        "en": "Violation of these Terms of Use.",
        "pt": "Violação destes Termos de Uso.",
        "es": "Violación de estos Términos de Uso."
    },
    "Improper sharing of protected content.": {
        "en": "Improper sharing of protected content.",
        "pt": "Compartilhamento indevido de conteúdo protegido.",
        "es": "Compartir indebidamente contenido protegido."
    },
    "Fraudulent use of the platform.": {
        "en": "Fraudulent use of the platform.",
        "pt": "Uso fraudulento da plataforma.",
        "es": "Uso fraudulento de la plataforma."
    },
    "In case of termination for cause, no refund will be issued for amounts paid.": {
        "en": "In case of termination for cause, no refund will be issued for amounts paid.",
        "pt": "Em caso de encerramento por justa causa, não haverá reembolso dos valores pagos.",
        "es": "En caso de cancelación por justa causa, no se realizarán reembolsos por los montos pagados."
    },
    "Limitation of liability": {
        "en": "Limitation of liability",
        "pt": "Limitação de responsabilidade",
        "es": "Limitación de responsabilidad"
    },
    "The platform is provided \"as is\". We are not responsible for:": {
        "en": "The platform is provided \"as is\". We are not responsible for:",
        "pt": "A plataforma é fornecida \"no estado em que se encontra\". Não nos responsabilizamos por:",
        "es": "La plataforma se proporciona \"tal como está\". No nos responsabilizamos por:"
    },
    "Learning outcomes, which depend on each student's effort and dedication.": {
        "en": "Learning outcomes, which depend on each student's effort and dedication.",
        "pt": "Resultados de aprendizado, que dependem do esforço e dedicação de cada aluno(a).",
        "es": "Los resultados de aprendizaje, que dependen del esfuerzo y dedicación de cada alumno(a)."
    },
    "Access issues resulting from the user's internet connection.": {
        "en": "Access issues resulting from the user's internet connection.",
        "pt": "Problemas de acesso decorrentes de conexão de internet do usuário.",
        "es": "Problemas de acceso derivados de la conexión a internet del usuario."
    },
    "Indirect damages or data loss due to third-party failures.": {
        "en": "Indirect damages or data loss due to third-party failures.",
        "pt": "Danos indiretos ou perda de dados por falhas de terceiros.",
        "es": "Daños indirectos o pérdida de datos por fallos de terceros."
    },
    "The processing of your personal data is governed by our": {
        "en": "The processing of your personal data is governed by our",
        "pt": "O tratamento dos seus dados pessoais é regido pela nossa",
        "es": "El tratamiento de sus datos personales se rige por nuestra"
    },
    "which is an integral part of these Terms of Use.": {
        "en": "which is an integral part of these Terms of Use.",
        "pt": "que faz parte integrante destes Termos de Uso.",
        "es": "que forma parte integrante de estos Términos de Uso."
    },
    "Changes to the Terms": {
        "en": "Changes to the Terms",
        "pt": "Alterações nos Termos",
        "es": "Cambios en los Términos"
    },
    "We may modify these Terms at any time. Significant changes will be communicated by email or platform notice with a minimum of 10 days' advance notice. Continued use of the platform after changes implies acceptance of the new terms.": {
        "en": "We may modify these Terms at any time. Significant changes will be communicated by email or platform notice with a minimum of 10 days' advance notice. Continued use of the platform after changes implies acceptance of the new terms.",
        "pt": "Podemos modificar estes Termos a qualquer momento. Alterações relevantes serão comunicadas por e-mail ou por aviso na plataforma com antecedência mínima de 10 dias. O uso contínuo da plataforma após as alterações implica aceitação dos novos termos.",
        "es": "Podemos modificar estos Términos en cualquier momento. Los cambios relevantes se comunicarán por correo electrónico o aviso en la plataforma con un mínimo de 10 días de anticipación. El uso continuo de la plataforma tras los cambios implica la aceptación de los nuevos términos."
    },
    "Applicable law and jurisdiction": {
        "en": "Applicable law and jurisdiction",
        "pt": "Legislação aplicável e foro",
        "es": "Legislación aplicable y fuero"
    },
    "These Terms are governed by the laws of the Federative Republic of Brazil. Any disputes will be submitted to the court of the consumer's place of residence, pursuant to the Consumer Protection Code.": {
        "en": "These Terms are governed by the laws of the Federative Republic of Brazil. Any disputes will be submitted to the court of the consumer's place of residence, pursuant to the Consumer Protection Code.",
        "pt": "Estes Termos são regidos pelas leis da República Federativa do Brasil. Eventuais disputas serão submetidas ao foro da comarca de domicílio do consumidor, nos termos do Código de Defesa do Consumidor.",
        "es": "Estos Términos se rigen por las leyes de la República Federativa de Brasil. Cualquier disputa será sometida al fuero del domicilio del consumidor, conforme al Código de Defensa del Consumidor."
    },
    "The": {
        "en": "The",
        "pt": "A",
        "es": "La"
    },
    "values your privacy. This document explains what data we collect, how we use it, and what your rights are, in compliance with the": {
        "en": "values your privacy. This document explains what data we collect, how we use it, and what your rights are, in compliance with the",
        "pt": "valoriza a sua privacidade. Este documento explica quais dados coletamos, como os utilizamos e quais são os seus direitos, em conformidade com a",
        "es": "valora su privacidad. Este documento explica qué datos recopilamos, cómo los usamos y cuáles son sus derechos, de conformidad con la"
    },
    "july 2026": {
        "en": "july 2026",
        "pt": "julho de 2026",
        "es": "julio de 2026"
    },
    "General Data Protection Law (LGPD - Law No. 13,709/2018)": {
        "en": "General Data Protection Law (LGPD - Law No. 13,709/2018)",
        "pt": "Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018)",
        "es": "Ley General de Protección de Datos (LGPD - Ley N.º 13.709/2018)"
    },
    "By using the platform, you agree to the terms of this Policy.": {
        "en": "By using the platform, you agree to the terms of this Policy.",
        "pt": "Ao utilizar a plataforma, você concorda com os termos desta Política.",
        "es": "Al utilizar la plataforma, usted acepta los términos de esta Política."
    },
    "We are an online language school offering recorded English courses, a streaming platform for purchased content, and a private lesson management tool - exclusive materials and management.": {
        "en": "We are an online language school offering recorded English courses, a streaming platform for purchased content, and a private lesson management tool - exclusive materials and management.",
        "pt": "Somos uma escola de idiomas online que oferece cursos gravados de inglês, plataforma de streaming dos conteúdos adquiridos e ferramenta de gerenciamento de aulas particulares - materiais exclusivos e gerenciamento.",
        "es": "Somos una escuela de idiomas en línea que ofrece cursos grabados de inglés, una plataforma de streaming para contenido comprado y una herramienta de gestión de clases particulares - materiales exclusivos y gestión."
    },
    "Data we collect": {
        "en": "Data we collect",
        "pt": "Dados que coletamos",
        "es": "Datos que recopilamos"
    },
    "We may collect the following categories of personal data:": {
        "en": "We may collect the following categories of personal data:",
        "pt": "Podemos coletar as seguintes categorias de dados pessoais:",
        "es": "Podemos recopilar las siguientes categorías de datos personales:"
    },
    "Registration data:": {
        "en": "Registration data:",
        "pt": "Dados de cadastro:",
        "es": "Datos de registro:"
    },
    "name, email, phone, and where applicable, CPF.": {
        "en": "name, email, phone, and where applicable, CPF.",
        "pt": "nome, e-mail, telefone e, quando aplicável, CPF.",
        "es": "nombre, correo electrónico, teléfono y, cuando corresponda, CPF."
    },
    "Access data:": {
        "en": "Access data:",
        "pt": "Dados de acesso:",
        "es": "Datos de acceso:"
    },
    "IP address, browser type, operating system, and browsing history on the platform.": {
        "en": "IP address, browser type, operating system, and browsing history on the platform.",
        "pt": "endereço IP, tipo de navegador, sistema operacional e histórico de navegação na plataforma.",
        "es": "dirección IP, tipo de navegador, sistema operativo e historial de navegación en la plataforma."
    },
    "Payment data:": {
        "en": "Payment data:",
        "pt": "Dados de pagamento:",
        "es": "Datos de pago:"
    },
    "processed by secure third-party gateways. We do not store card data on our servers.": {
        "en": "processed by secure third-party gateways. We do not store card data on our servers.",
        "pt": "processados por gateways terceirizados seguros. Não armazenamos dados de cartão em nossos servidores.",
        "es": "procesados por pasarelas de terceros seguras. No almacenamos datos de tarjetas en nuestros servidores."
    },
    "Progress data:": {
        "en": "Progress data:",
        "pt": "Dados de progresso:",
        "es": "Datos de progreso:"
    },
    "purchased courses, watched lessons, and exclusive materials accessed.": {
        "en": "purchased courses, watched lessons, and exclusive materials accessed.",
        "pt": "cursos adquiridos, aulas assistidas e materiais exclusivos acessados.",
        "es": "cursos comprados, lecciones vistas y materiales exclusivos accedidos."
    },
    "Communications:": {
        "en": "Communications:",
        "pt": "Comunicações:",
        "es": "Comunicaciones:"
    },
    "messages exchanged with platform support.": {
        "en": "messages exchanged with platform support.",
        "pt": "mensagens trocadas entre o suporte da plataforma.",
        "es": "mensajes intercambiados con el soporte de la plataforma."
    },
    "Cookies and similar technologies": {
        "en": "Cookies and similar technologies",
        "pt": "Cookies e tecnologias similares",
        "es": "Cookies y tecnologías similares"
    },
    "We use the following cookies on the platform:": {
        "en": "We use the following cookies on the platform:",
        "pt": "Utilizamos os seguintes cookies na plataforma:",
        "es": "Utilizamos las siguientes cookies en la plataforma:"
    },
    "Essential": {
        "en": "Essential",
        "pt": "Essencial",
        "es": "Esencial"
    },
    "Essential session cookie. Stores the authentication token (JWT) required to keep you logged in and control access to your account and purchased content.": {
        "en": "Essential session cookie. Stores the authentication token (JWT) required to keep you logged in and control access to your account and purchased content.",
        "pt": "Cookie de sessão essencial. Armazena o token de autenticação (JWT) necessário para manter você conectado e controlar o acesso à sua conta e aos conteúdos adquiridos.",
        "es": "Cookie de sesión esencial. Almacena el token de autenticación (JWT) necesario para mantenerlo conectado y controlar el acceso a su cuenta y contenido comprado."
    },
    "This cookie is strictly necessary for the platform to function and cannot be disabled.": {
        "en": "This cookie is strictly necessary for the platform to function and cannot be disabled.",
        "pt": "Este cookie é estritamente necessário para o funcionamento da plataforma e não pode ser desativado.",
        "es": "Esta cookie es estrictamente necesaria para el funcionamiento de la plataforma y no puede desactivarse."
    },
    "We do not use advertising tracking cookies, third-party cookies for marketing purposes, or intrusive behavioral analysis tools.": {
        "en": "We do not use advertising tracking cookies, third-party cookies for marketing purposes, or intrusive behavioral analysis tools.",
        "pt": "Não utilizamos cookies de rastreamento publicitário, cookies de terceiros para fins de marketing nem ferramentas de análise comportamental intrusiva.",
        "es": "No utilizamos cookies de seguimiento publicitario, cookies de terceros con fines de marketing ni herramientas de análisis de comportamiento intrusivas."
    },
    "Purpose of data use": {
        "en": "Purpose of data use",
        "pt": "Finalidade do uso dos dados",
        "es": "Finalidad del uso de datos"
    },
    "Create and manage your account": {
        "en": "Create and manage your account",
        "pt": "Criar e gerenciar sua conta de acesso",
        "es": "Crear y gestionar su cuenta"
    },
    "Grant access to purchased courses and materials": {
        "en": "Grant access to purchased courses and materials",
        "pt": "Liberar o acesso aos cursos e materiais adquiridos",
        "es": "Conceder acceso a cursos y materiales comprados"
    },
    "Register and manage private students": {
        "en": "Register and manage private students",
        "pt": "Registrar e gerenciar alunos particulares",
        "es": "Registrar y gestionar alumnos particulares"
    },
    "Process payments and issue receipts": {
        "en": "Process payments and issue receipts",
        "pt": "Processar pagamentos e emitir comprovantes",
        "es": "Procesar pagos y emitir comprobantes"
    },
    "Send communications related to your learning": {
        "en": "Send communications related to your learning",
        "pt": "Enviar comunicações relacionadas ao seu aprendizado",
        "es": "Enviar comunicaciones relacionadas con su aprendizaje"
    },
    "Ensure the security and proper functioning of the platform": {
        "en": "Ensure the security and proper functioning of the platform",
        "pt": "Garantir a segurança e o correto funcionamento da plataforma",
        "es": "Garantizar la seguridad y el correcto funcionamiento de la plataforma"
    },
    "Comply with legal and regulatory obligations": {
        "en": "Comply with legal and regulatory obligations",
        "pt": "Cumprir obrigações legais e regulatórias",
        "es": "Cumplir obligaciones legales y regulatorias"
    },
    "Legal basis for processing": {
        "en": "Legal basis for processing",
        "pt": "Base legal para o tratamento",
        "es": "Base legal para el tratamiento"
    },
    "Contract performance": {
        "en": "Contract performance",
        "pt": "Execução de contrato",
        "es": "Ejecución de contrato"
    },
    "For providing purchased courses and services.": {
        "en": "For providing purchased courses and services.",
        "pt": "Para fornecimento dos cursos e serviços adquiridos.",
        "es": "Para la prestación de cursos y servicios comprados."
    },
    "Consent": {
        "en": "Consent",
        "pt": "Consentimento",
        "es": "Consentimiento"
    },
    "For sending marketing communications, when applicable.": {
        "en": "For sending marketing communications, when applicable.",
        "pt": "Para envio de comunicações de marketing, quando aplicável.",
        "es": "Para el envío de comunicaciones de marketing, cuando corresponda."
    },
    "Legitimate interest": {
        "en": "Legitimate interest",
        "pt": "Legítimo interesse",
        "es": "Interés legítimo"
    },
    "For platform security and service improvement.": {
        "en": "For platform security and service improvement.",
        "pt": "Para segurança da plataforma e melhoria dos serviços.",
        "es": "Para la seguridad de la plataforma y la mejora de los servicios."
    },
    "Legal obligation": {
        "en": "Legal obligation",
        "pt": "Obrigação legal",
        "es": "Obligación legal"
    },
    "When required by law or competent authority.": {
        "en": "When required by law or competent authority.",
        "pt": "Quando exigido por lei ou autoridade competente.",
        "es": "Cuando lo exija la ley o una autoridad competente."
    },
    "Data sharing": {
        "en": "Data sharing",
        "pt": "Compartilhamento de dados",
        "es": "Compartir datos"
    },
    "We do not sell, rent, or share your personal data with third parties for commercial purposes. We may share data only in the following situations:": {
        "en": "We do not sell, rent, or share your personal data with third parties for commercial purposes. We may share data only in the following situations:",
        "pt": "Não vendemos, alugamos nem cedemos seus dados pessoais a terceiros para fins comerciais. Podemos compartilhar dados apenas nas seguintes situações:",
        "es": "No vendemos, alquilamos ni cedemos sus datos personales a terceros con fines comerciales. Podemos compartir datos solo en las siguientes situaciones:"
    },
    "With payment processors, to complete financial transactions.": {
        "en": "With payment processors, to complete financial transactions.",
        "pt": "Com processadores de pagamento, para conclusão de transações financeiras.",
        "es": "Con procesadores de pago, para completar transacciones financieras."
    },
    "With hosting and infrastructure providers, under confidentiality agreements.": {
        "en": "With hosting and infrastructure providers, under confidentiality agreements.",
        "pt": "Com provedores de hospedagem e infraestrutura, sob acordos de confidencialidade.",
        "es": "Con proveedores de alojamiento e infraestructura, bajo acuerdos de confidencialidad."
    },
    "With public authorities, when required by law or court order.": {
        "en": "With public authorities, when required by law or court order.",
        "pt": "Com autoridades públicas, quando exigido por lei ou ordem judicial.",
        "es": "Con autoridades públicas, cuando lo exija la ley o una orden judicial."
    },
    "Storage and security": {
        "en": "Storage and security",
        "pt": "Armazenamento e segurança",
        "es": "Almacenamiento y seguridad"
    },
    "Your data is stored on secure servers. We adopt technical and administrative measures to protect your data against unauthorized access, loss, alteration, or improper disclosure. The authentication token (cookie": {
        "en": "Your data is stored on secure servers. We adopt technical and administrative measures to protect your data against unauthorized access, loss, alteration, or improper disclosure. The authentication token (cookie",
        "pt": "Seus dados são armazenados em servidores seguros. Adotamos medidas técnicas e administrativas para proteger seus dados contra acessos não autorizados, perda, alteração ou divulgação indevida. O token de autenticação (cookie",
        "es": "Sus datos se almacenan en servidores seguros. Adoptamos medidas técnicas y administrativas para proteger sus datos contra accesos no autorizados, pérdida, alteración o divulgación indebida. El token de autenticación (cookie"
    },
    ") is generated with an expiration date and automatically invalidated when the session ends.": {
        "en": ") is generated with an expiration date and automatically invalidated when the session ends.",
        "pt": ") é gerado com prazo de validade e invalidado automaticamente ao encerrar a sessão.",
        "es": ") se genera con una fecha de vencimiento y se invalida automáticamente al cerrar la sesión."
    },
    "Your rights (LGPD)": {
        "en": "Your rights (LGPD)",
        "pt": "Seus direitos (LGPD)",
        "es": "Sus derechos (LGPD)"
    },
    "Under the LGPD, you have the right to:": {
        "en": "Under the LGPD, you have the right to:",
        "pt": "Nos termos da LGPD, você tem direito a:",
        "es": "Conforme a la LGPD, usted tiene derecho a:"
    },
    "Confirm whether we process your personal data": {
        "en": "Confirm whether we process your personal data",
        "pt": "Confirmar se tratamos seus dados pessoais",
        "es": "Confirmar si tratamos sus datos personales"
    },
    "Access the data we hold about you": {
        "en": "Access the data we hold about you",
        "pt": "Acessar os dados que temos sobre você",
        "es": "Acceder a los datos que tenemos sobre usted"
    },
    "Correct incomplete or outdated data": {
        "en": "Correct incomplete or outdated data",
        "pt": "Corrigir dados incompletos ou desatualizados",
        "es": "Corregir datos incompletos o desactualizados"
    },
    "Request anonymization, blocking, or deletion": {
        "en": "Request anonymization, blocking, or deletion",
        "pt": "Solicitar anonimização, bloqueio ou eliminação",
        "es": "Solicitar anonimización, bloqueo o eliminación"
    },
    "Withdraw consent at any time": {
        "en": "Withdraw consent at any time",
        "pt": "Revogar o consentimento a qualquer momento",
        "es": "Retirar el consentimiento en cualquier momento"
    },
    "Request data portability": {
        "en": "Request data portability",
        "pt": "Solicitar a portabilidade dos seus dados",
        "es": "Solicitar la portabilidad de sus datos"
    },
    "Obtain information about third-party sharing": {
        "en": "Obtain information about third-party sharing",
        "pt": "Obter informações sobre compartilhamento com terceiros",
        "es": "Obtener información sobre el intercambio con terceros"
    },
    "Changes to this policy": {
        "en": "Changes to this policy",
        "pt": "Alterações nesta política",
        "es": "Cambios en esta política"
    },
    "We may update this Policy periodically. When significant changes occur, we will notify you by email or platform notice. The \"last updated\" date at the top of this document indicates when the current version was published.": {
        "en": "We may update this Policy periodically. When significant changes occur, we will notify you by email or platform notice. The \"last updated\" date at the top of this document indicates when the current version was published.",
        "pt": "Podemos atualizar esta Política periodicamente. Quando houver alterações relevantes, notificaremos você por e-mail ou por aviso na plataforma. A data de \"última atualização\" no topo deste documento indica quando a versão vigente foi publicada.",
        "es": "Podemos actualizar esta Política periódicamente. Cuando se produzcan cambios relevantes, le notificaremos por correo electrónico o aviso en la plataforma. La fecha de \"última actualización\" en la parte superior indica cuándo se publicó la versión vigente."
    },
    "Privacy": {
        "en": "Privacy",
        "pt": "Privacidade",
        "es": "Privacidad"
    },
    "Streaming": {
        "en": "Streaming",
        "pt": "Streaming",
        "es": "Streaming"
    },
    "This course includes:": {
        "en": "This course includes:",
        "pt": "Este curso inclui:",
        "es": "Este curso incluye:"
    },
    'create account': {
        en: 'create account',
        pt: 'criar uma conta',
        es: 'crear una cuenta'
    },
    'Please provide your information below to proceed with registering your account.': {
        en: 'Please provide your information below to proceed with registering your account.',
        pt: 'Por favor, forneça suas informações abaixo para prosseguir com o registro da sua conta.',
        es: 'Por favor, proporcione su información a continuación para continuar con el registro de su cuenta.'
    },
    'password': {
        en: 'password',
        pt: 'senha',
        es: 'contraseña'
    },
    'I agree and accept the': {
        en: 'I agree and accept the',
        pt: 'Concordo e aceito o',
        es: 'Estoy de acuerdo y acepto el'
    },
    'Do you already have an account?': {
        en: 'Do you already have an account?',
        pt: 'Você já possui uma conta?',
        es: '¿Ya tienes una cuenta?'
    },
    'log in': {
        en: 'log in',
        pt: 'acessar',
        es: 'accesar'
    },
    'Please provide your name': {
        en: 'Please provide your name',
        pt: 'Por favor, forneça seu nome',
        es: 'Por favor proporcione su nombre'
    },
    'Please provide your email address': {
        en: 'Please provide your email address',
        pt: 'Por favor, forneça seu endereço de e-mail.',
        es: 'Por favor, proporcione su dirección de correo electrónico'
    },
    'Please enter your password': {
        en: 'Please enter your password',
        pt: 'Por favor digite sua senha',
        es: 'Por favor ingrese su contraseña'
    },
    'the email address is invalid.': {
        en: 'the email address is invalid.',
        pt: 'oendereço de e-mail é inválido.',
        es: 'la dirección de correo electrónico no es válida.'
    },
    'You must agree to our terms to create your account.': {
        en: 'You must agree to our terms to create your account.',
        pt: 'Você precisa concordar com nossos termos para criar sua conta.',
        es: 'Para crear tu cuenta, debes aceptar nuestros términos y condiciones.'
    },
    'Welcome!': {
        en: 'Welcome!',
        pt: 'Bem-vindo!',
        es: '¡Bienvenido!'
    },
    'Enter your email and password to log in to your account.': {
        en: 'Enter your email and password to log in to your account.',
        pt: 'Insira seu e-mail e senha para acessar sua conta.',
        es: 'Introduce tu correo electrónico y contraseña para iniciar sesión en tu cuenta.'
    },
    'Remember password': {
        en: 'Remember password',
        pt: 'Lembrar senha',
        es: 'Recordar contraseña'
    },
    'I forgot my password.': {
        en: 'I forgot my password.',
        pt: 'Esqueci minha senha.',
        es: 'Olvidé mi contraseña.'
    },
    "Don't have an account yet?": {
        en: "Don't have an account yet?",
        pt: 'Ainda não tem uma conta?',
        es: '¿Aún no tienes una cuenta?'
    },
    'Login successful, welcome': {
        en: 'Login successful, welcome',
        pt: 'Login efetuado com sucesso, seja bem-vindo(a)',
        es: 'Inicio de sesión exitoso, bienvenido'
    },
    'Enter the code you received in your email': {
        en: 'Enter the code you received in your email',
        pt: 'Insira o código que você recebeu no seu e-mail',
        es: 'Introduce el código que recibiste en tu correo electrónico'
    },
    'did not receive your code? Check your spam.': {
        en: 'did not receive your code? Check your spam.',
        pt: 'não recebeu seu código? Verifique sua caixa de spam.',
        es: '¿No recibiste tu código? Revisa tu carpeta de correo no deseado.'
    },
    'go back to homepage': {
        en: 'go back to homepage',
        pt: 'voltar à página inicial',
        es: 'volver a la página principal'
    },
    'resend code': {
        en: 'resend code',
        pt: 'reenviar código',
        es: 'reenviar código'
    },
    'verify email': {
        en: 'verify email',
        pt: 'verificar e-mail',
        es: 'verificar correo electrónico'
    },
    'We sent a confirmation code to': {
        en: 'We sent a confirmation code to',
        pt: 'Enviamos um código de confirmação para',
        es: 'Nosotros enviamos un código de confirmación a'
    },
    'Send new email confirmation code': {
        en: 'Send new email confirmation code',
        pt: 'Enviar novo código de confirmação por e-mail',
        es: 'Enviar nuevo código de confirmación por correo electrónico'
    },
    'wait': {
        en: 'wait',
        pt: 'espere',
        es: 'espere'
    },
    'enter your email': {
        en: 'enter your email',
        pt: 'digite seu e-mail',
        es: 'ingresa tu correo electrónico'
    },
    'enter your password': {
        en: 'enter your password',
        pt: 'digite sua senha',
        es: 'ingresa tu contraseña'
    },
    'send': {
        en: 'send',
        pt: 'enviar',
        es: 'enviar'
    },
    'email not verified, confirm your email and password to receive a new email verification code': {
        en: 'email not verified, confirm your email and password to receive a new email verification code',
        pt: 'e-mail não verificado. Confirme seu e-mail e senha para receber um novo código de verificação por e-mail',
        es: 'correo electrónico no verificado, confirme su correo electrónico y contraseña para recibir un nuevo código de verificación de correo electrónico'
    },
    'email and password are required': {
        en: 'email and password are required',
        pt: 'é necessário fornecer um e-mail e uma senha',
        es: 'se requiere correo electrónico y contraseña'
    },
    'new email sent': {
        en: 'new email sent',
        pt: 'novo e-mail enviado',
        es: 'nuevo correo electrónico enviado'
    },
    'email verified': {
        en: 'email verified',
        pt: 'e-mail verificado',
        es: 'correo electrónico verificado'
    },
    'Reset your password': {
        en: 'Reset your password',
        pt: 'Redefinir sua senha',
        es: 'Restablece tu contraseña'
    },
    'Enter your email address and we will send you a code to reset your password.': {
        en: 'Enter your email address and we will send you a code to reset your password.',
        pt: 'Insira seu endereço de e-mail e enviaremos um código para redefinir sua senha.',
        es: 'Introduce tu dirección de correo electrónico y te enviaremos un código para restablecer tu contraseña.'
    },
    'your email': {
        en: 'your email',
        pt: 'seu e-mail',
        es: 'tu correo electrónico'
    },
    'send recovery code': {
        en: 'send recovery code',
        pt: 'enviar código de recuperação',
        es: 'enviar código de recuperación'
    },
    'check your spam folder if you do not see the email.': {
        en: 'check your spam folder if you do not see the email.',
        pt: 'verifique sua pasta de spam caso não encontre o e-mail.',
        es: 'si no ve el correo electrónico, revise su carpeta de correo no deseado.'
    },
    'back to login': {
        en: 'back to login',
        pt: 'voltar ao login',
        es: 'volver a iniciar sesión'
    },
    'Enter the recovery code': {
        en: 'Enter the recovery code',
        pt: 'Digite o código de recuperação',
        es: 'Ingrese el código de recuperación'
    },
    'We sent a recovery code to': {
        en: 'We sent a recovery code to',
        pt: 'Enviamos um código de recuperação para',
        es: 'Nosotros enviamos un código de recuperación a'
    },
    'verify code': {
        en: 'verify code',
        pt: 'verificar código',
        es: 'verificar código'
    },
    'You can resend in': {
        en: 'You can resend in',
        pt: 'Você pode reenviar',
        es: 'Puedes volver a enviarlo'
    },
    'Create new password': {
        en: 'Create new password',
        pt: 'Criar nova senha',
        es: 'Crear nueva contraseña'
    },
    'Type your new password below to reset your access.': {
        en: 'Type your new password below to reset your access.',
        pt: 'Digite sua nova senha abaixo para redefinir seu acesso.',
        es: 'Introduce tu nueva contraseña a continuación para restablecer tu acceso.'
    },
    'new password': {
        en: 'new password',
        pt: 'nova Senha',
        es: 'nueva contraseña'
    },
    'confirm password': {
        en: 'confirm password',
        pt: 'confirme sua senha',
        es: 'confirmar Contraseña'
    },
    'save new password': {
        en: 'save new password',
        pt: 'salvar nova senha',
        es: 'guardar nueva contraseña'
    },
    'invalid or expired password reset link': {
        en: 'invalid or expired password reset link',
        pt: 'link para redefinição de senha inválido ou expirado',
        es: 'enlace para restablecer contraseña no válida o caducada'
    },
    'minutes': {
        en: 'minutes',
        pt: 'minutos',
        es: 'minutos'
    },
    'the course access expired, you must buy again to regain access': {
        en: 'the course access expired, you must buy again to regain access',
        pt: 'o acesso ao curso expirou. Você precisa comprar novamente para recuperar o acesso',
        es: 'el acceso al curso ha caducado. Debe comprarlo de nuevo para recuperarlo'
    },
    'rebuy course': {
        en: 'rebuy course',
        pt: 'recomprar curso',
        es: 'curso de recompra'
    },
    'you already have bought some of these courses, please check': {
        en: 'you already have bought some of these courses, please check',
        pt: 'você já adquiriu alguns desses cursos? Por favor, verifique',
        es: 'ya has comprado algunos de estos cursos, por favor, compruébalo'
    },
    'payment receipt': {
        en: 'payment receipt',
        pt: 'recibo de pagamento',
        es: 'recibo de pago'
    },
    'paid': {
        en: 'paid',
        pt: 'pago',
        es: 'pagado'
    },
    'emission': {
        en: 'emission',
        pt: 'emissão',
        es: 'emisión'
    },
    'provider': {
        en: 'provider',
        pt: 'provedor',
        es: 'proveedor'
    },
    'purchase information': {
        en: 'purchase information',
        pt: 'informações de compra',
        es: 'información de compra'
    },
    'export to pdf': {
        en: 'export to pdf',
        pt: 'exportar para pdf',
        es: 'exportar a pdf'
    },
    'payment not found': {
        en: 'payment not found',
        pt: 'pagamento não encontrado',
        es: 'pago no encontrado'
    },
    'buyer': {
        en: 'buyer',
        pt: 'comprador',
        es: 'comprador'
    },
    'transaction number': {
        en: 'transaction number',
        pt: 'número da transação',
        es: 'número de transacción'
    },
    'You will receive a new period of 12 months.': {
        en: 'You will receive a new period of 12 months.',
        pt: 'Você receberá um novo período de 12 meses.',
        es: 'Recibirás un nuevo período de 12 meses.'
    },
    'Purchase information:': {
        en: 'Purchase information:',
        pt: 'Informações de compra',
        es: 'Información de compra'
    },
    'Transaction number:': {
        en: 'Transaction number:',
        pt: 'Número da transação',
        es: 'Número de transacción'
    },
    'payment received': {
        en: 'payment received',
        pt: 'pagamento recebido',
        es: 'pago recibido'
    },
    'social': {
        en: 'social',
        pt: 'social',
        es: 'social'
    },
    'developed with passion by': {
        en: 'developed with passion by',
        pt: 'desenvolvido com paixão por',
        es: 'desarrollado con pasión por'
    },
    'A wide selection of courses': {
        en: 'A wide selection of courses',
        pt: 'Uma ampla seleção de cursos',
        es: 'Una amplia selección de cursos'
    },
    'Pillars': {
        en: 'Pillars',
        pt: 'Pilares',
        es: 'Pilares'
    },
    'Communicative approach': {
        en: 'Communicative approach',
        pt: 'Abordagem comunicativa',
        es: 'Enfoque comunicativo'
    },
    'Lessons focused on communication (but without neglecting other skills) with relevant everyday topics. Nothing could be closer to learning about life in English, right?': {
        en: 'Lessons focused on communication (but without neglecting other skills) with relevant everyday topics. Nothing could be closer to learning about life in English, right?',
        pt: 'Aulas focadas na comunicação (mas sem negligenciar outras habilidades) com temas relevantes do dia a dia. Nada melhor para aprender sobre a vida em inglês, não é?',
        es: 'Clases centradas en la comunicación (sin descuidar otras habilidades) con temas cotidianos relevantes. ¿Verdad que es mejor aprender sobre la vida en inglés?'
    },
    'Acceptance and respect': {
        en: 'Acceptance and respect',
        pt: 'Aceitação e respeito',
        es: 'Aceptación y respeto'
    },
    "Here, respecting the student's pace is essential. We want you to feel comfortable and encouraged to speak without pressure or being told about mistakes or accent – ​​just be kind to your journey, cutie!": {
        en: "Here, respecting the student's pace is essential. We want you to feel comfortable and encouraged to speak without pressure or being told about mistakes or accent – ​​just be kind to your journey, cutie!",
        pt: "Aqui, respeitar o ritmo do aluno é essencial. Queremos que você se sinta confortável e encorajado a falar sem pressão, sem ser repreendido por erros ou sotaque – apenas seja gentil com a sua jornada, querido(a)!",
        es: "Aquí, respetar el ritmo del estudiante es fundamental. Queremos que te sientas cómodo y animado a hablar sin presión ni que te digan que te equivocas o que tienes acento. ¡Simplemente disfruta de tu aprendizaje!"
    },
    'Individual monitoring': {
        en: 'Individual monitoring',
        pt: 'Monitoramento individual',
        es: 'Monitoreo individual'
    },
    'Feedback and emotional and educational support are part of our DNA, because we know the importance of this support and care throughout a new learning process.': {
        en: 'Feedback and emotional and educational support are part of our DNA, because we know the importance of this support and care throughout a new learning process.',
        pt: 'O feedback e o apoio emocional e educacional fazem parte do nosso DNA, porque sabemos da importância desse apoio e cuidado ao longo de um novo processo de aprendizagem.',
        es: 'La retroalimentación y el apoyo emocional y educativo forman parte de nuestro ADN, porque conocemos la importancia de este apoyo y cuidado a lo largo de un nuevo proceso de aprendizaje.'
    },
    'Custom Notion': {
        en: 'Custom Notion',
        pt: 'Noção personalizada',
        es: 'Noción personalizada'
    },
    'A personalized, organized, and attractive environment to find all the necessary information about classes, assignments, English in your daily routine, contracts, and everything else you need on this journey.': {
        en: 'A personalized, organized, and attractive environment to find all the necessary information about classes, assignments, English in your daily routine, contracts, and everything else you need on this journey.',
        pt: 'Um ambiente personalizado, organizado e atraente para encontrar todas as informações necessárias sobre aulas, tarefas, inglês no seu dia a dia, contratos e tudo o mais que você precisa nessa jornada.',
        es: 'Un entorno personalizado, organizado y atractivo donde encontrar toda la información necesaria sobre clases, tareas, el inglés en tu día a día, contratos y todo lo demás que necesites en este camino.'
    },
    'What our students are saying': {
        en: 'What our students are saying',
        pt: 'O que nossos alunos estão dizendo',
        es: 'Lo que dicen nuestros estudiantes'
    },
    'Insights & Articles': {
        en: 'Insights & Articles',
        pt: 'Análises e artigos',
        es: 'Análisis y artículos'
    },
    'Learning tips and news from Teacher Maestra Victoria.': {
        en: 'Learning tips and news from Teacher Maestra Victoria.',
        pt: 'Dicas de aprendizagem e novidades da professora Victoria.',
        es: 'Consejos de aprendizaje y novedades de la Maestra Victoria.'
    },
    'recovery code sent successfully': {
        en: 'recovery code sent successfully',
        pt: 'código de recuperação enviado com sucesso',
        es: 'código de recuperación enviado exitosamente'
    },
    'online english and spanish with': {
        en: 'online English and Spanish with',
        pt: 'Inglês e Espanhol online com',
        es: 'Inglés y Español en línea con'
    },
    'new code resent successfully': {
        en: 'new code resent successfully',
        pt: 'novo código reenviado com sucesso',
        es: 'el nuevo código se ha reenviado correctamente'
    },
    'no calls found.': {
        en: 'no calls found.',
        pt: 'nenhum chamado encontrado.',
        es: 'no se encontraron llamadas.'
    },
    'open a support ticket and track the status of your requests.': {
        en: 'open a support ticket and track the status of your requests.',
        pt: 'abra um chamado de suporte e acompanhe o status de suas solicitações.',
        es: 'abra un ticket de soporte y haga un seguimiento del estado de sus solicitudes.'
    },
    'open': {
        en: 'open',
        pt: 'aberto',
        es: 'abierto'
    },
    'open New Call': {
        en: 'open New Call',
        pt: 'abrir Novo Chamado',
        es: 'abrir Nueva Convocatoria'
    },
    'call title': {
        en: 'call title',
        pt: 'título do chamado',
        es: 'título de la convocatoria'
    },
    'closed': {
        en: 'closed',
        pt: 'fechado',
        es: 'cerrado'
    },
    'message': {
        en: 'message',
        pt: 'mensagem',
        es: 'mensaje'
    },
    'send Call': {
        en: 'send Call',
        pt: 'enviar Chamado',
        es: 'enviar Llamada'
    },
    'briefly describe the problem': {
        en: 'send Call',
        pt: 'enviar Chamado',
        es: 'enviar Llamada'
    },
    'no reason selected': {
        en: 'send Call',
        pt: 'enviar Chamado',
        es: 'enviar Llamada'
    },
    'Select a course (optional)': {
        en: 'Select a course (optional)',
        pt: 'Selecione um curso (opcional)',
        es: 'Seleccione un curso (opcional)'
    },
    'Search course...': {
        en: 'Search course...',
        pt: 'Buscar curso...',
        es: 'Buscar curso...'
    },
    'No available options': {
        en: 'No available options',
        pt: 'Nenhuma opção disponível',
        es: 'No hay opciones disponibles'
    },
    'password updated': {
        en: 'password updated',
        pt: 'senha atualizada',
        es: 'contraseña actualizada'
    },
    'search courses': {
        en: 'search courses',
        pt: 'pesquisar cursos',
        es: 'buscar cursos'
    },
    'see all': {
        en: 'see all',
        pt: 'ver todos',
        es: 'ver todos'
    },
    'No courses found yet. We are producing new content right now!': {
        en: 'No courses found yet. We are producing new content right now!',
        pt: 'Nenhum curso encontrado ainda. Estamos produzindo conteúdo novo agora mesmo!',
        es: 'Não se encontraron cursos aún. ¡Estamos produciendo contenido nuevo ahora mismo!'
    },
    'basic I': {
        en: 'basic I',
        pt: 'básico I',
        es: 'básico I'
    },
    'basic II': {
        en: 'basic II',
        pt: 'básico II',
        es: 'básico II'
    },
    'intermediate I': {
        en: 'intermediate I',
        pt: 'intermediário I',
        es: 'intermediário I'
    },
    'intermediate II': {
        en: 'intermediate II',
        pt: 'intermediário II',
        es: 'intermediário II'
    },
    'advanced I': {
        en: 'advanced I',
        pt: 'avançado I',
        es: 'avançado I'
    },
    'advanced II': {
        en: 'advanced II',
        pt: 'avançado II',
        es: 'avançado II'
    },
    'select a level': {
        en: 'select a level',
        pt: 'selecione um nível',
        es: 'selecciona un nivel'
    },
    'conversation': {
        en: 'conversation',
        pt: 'conversation',
        es: 'conversation'
    },
    'teen I': {
        en: 'teen I',
        pt: 'teen I',
        es: 'teen I'
    },
    'Course already purchased': {
        en: 'Course already purchased',
        pt: 'Curso já adquirido',
        es: 'Curso ya adquirido'
    },
    'Below are the material packages you have purchased. Click details to view and download files.': {
        en: 'Below are the material packages you have purchased. Click details to view and download files.',
        pt: 'Abaixo estão os pacotes de materiais que você adquiriu. Clique em "detalhes" para visualizar e baixar os arquivos.',
        es: 'A continuación, se muestran los paquetes de materiales que ha adquirido. Haga clic en «Detalles» para ver y descargar los archivos.'
    },
    'My Purchased Materials': {
        en: 'My Purchased Materials',
        pt: 'Meus Materiais Adquiridos',
        es: 'Mis materiales adquiridos'
    },
    'no purchased material found.': {
        en: 'no purchased material found.',
        pt: 'Nenhum material adquirido foi encontrado.',
        es: 'No se encontró material adquirido.'
    },
    'no description available.': {
        en: 'no description available.',
        pt: 'Nenhuma descrição disponível.',
        es: 'No hay descripción disponible.'
    },
    'files in this package': {
        en: 'files in this package',
        pt: 'arquivos neste pacote',
        es: 'archivos de este paquete'
    },
    'no files available in this package.': {
        en: 'no files available in this package.',
        pt: 'Não há arquivos disponíveis neste pacote.',
        es: 'No hay archivos disponibles en este paquete.'
    },
    'error loading materials': {
        en: 'error loading materials',
        pt: 'erro ao carregar materiais',
        es: 'error al cargar los materiales'
    },
    'files': {
        en: 'files',
        pt: 'arquivos',
        es: 'archivos'
    },
    'package files': {
        en: 'package files',
        pt: 'arquivos do pacote',
        es: 'archivos del paquete'
    },
    'close': {
        en: 'close',
        pt: 'fechar',
        es: 'cerrar'
    },
    "teacher's materials": {
        en: "teacher's materials",
        pt: 'materiais para professor',
        es: 'materiales para profesor'
    },
    "material for teachers": {
        "en": "Material for teachers",
        "pt": "Materiais para professor",
        "es": "Materiales para profesor"
    },
    "less time": {
        "en": "Less time",
        "pt": "Menos tempo",
        "es": "Menos tiempo"
    },
    "planning.": {
        "en": "planning.",
        "pt": "planejando.",
        "es": "planificando."
    },
    "teaching.": {
        "en": "teaching.",
        "pt": "ensinando.",
        "es": "enseñando."
    },
    "ready-made, beautiful materials designed to make your classroom routine easier without leaving behind creativity and your way of teaching.": {
        "en": "Ready-made, beautiful materials designed to make your classroom routine easier without leaving behind creativity and your way of teaching.",
        "pt": "Materiais prontos, bonitos e pensados para facilitar a sua rotina em sala de aula sem deixar de lado a criatividade e a sua forma de ensinar.",
        "es": "Materiales listos, hermosos y diseñados para facilitar tu rutina en el aula, sin dejar de lado la creatividad y tu forma de enseñar."
    },
    "explore materials": {
        "en": "Explore materials",
        "pt": "Conhecer os materiais",
        "es": "Conocer los materiales"
    },
    "how it works": {
        "en": "How it works",
        "pt": "Como funciona",
        "es": "Cómo funciona"
    },
    "teacher materials": {
        "en": "Teacher materials",
        "pt": "Materiais de professor",
        "es": "Materiales de profesor"
    },
    "for your": {
        "en": "For your",
        "pt": "Para a sua",
        "es": "Para tu"
    },
    "routine": {
        "en": "routine",
        "pt": "rotina",
        "es": "rutina"
    },
    "teach": {
        "en": "Teach",
        "pt": "Ensinar",
        "es": "Enseñar"
    },
    "organize": {
        "en": "Organize",
        "pt": "Organizar",
        "es": "Organizar"
    },
    "let's be honest?": {
        "en": "Let's be honest?",
        "pt": "Vamos falar a verdade?",
        "es": "¿Vamos a ser honestos?"
    },
    "you didn't start": {
        "en": "You didn't start",
        "pt": "Você não começou a",
        "es": "No começaste a"
    },
    "teaching": {
        "en": "teaching",
        "pt": "ensinar",
        "es": "enseñar"
    },
    "to spend your life searching for material.": {
        "en": "to spend your life searching for material.",
        "pt": "para passar a vida procurando material.",
        "es": "para pasar tu vida buscando material."
    },
    "between preparing lessons, adapting activities, researching references, and thinking of different ways to engage students, planning can end up taking far more time than it should.": {
        "en": "Between preparing lessons, adapting activities, researching references, and thinking of different ways to engage students, planning can end up taking far more time than it should.",
        "pt": "Entre preparar aulas, adaptar atividades, pesquisar referências e pensar em maneiras diferentes de envolver os alunos, o planejamento pode acabar ocupando muito mais tempo do que deveria.",
        "es": "Entre preparar clases, adaptar actividades, investigar referencias y pensar en diferentes formas de involucrar a los estudiantes, la planificación puede terminar tomando mucho más tiempo del que debería."
    },
    "wasting precious hours": {
        "en": "Wasting precious hours",
        "pt": "Perdendo horas preciosas",
        "es": "Perdiendo horas preciosas"
    },
    "searching for references, activities, images, and materials for every class.": {
        "en": "Searching for references, activities, images, and materials for every class.",
        "pt": "Procurando referências, atividades, imagens e materiais para cada aula.",
        "es": "Buscando referencias, actividades, imágenes y materiales para cada clase."
    },
    "arriving tired at class": {
        "en": "Arriving tired at class",
        "pt": "Chegando cansada na aula",
        "es": "Llegando cansada a la clase"
    },
    "because much of your energy went away before even starting.": {
        "en": "Because much of your energy went away before even starting.",
        "pt": "Porque boa parte da sua energia foi embora antes mesmo de começar.",
        "es": "Porque gran parte de tu energía se fue antes de empezar."
    },
    "repeating the same activities": {
        "en": "Repeating the same activities",
        "pt": "Repetindo sempre as mesmas atividades",
        "es": "Repitiendo siempre las mismas actividades"
    },
    "even knowing that your students could be much more engaged.": {
        "en": "Even knowing that your students could be much more engaged.",
        "pt": "Mesmo sabendo que seus alunos poderiam se envolver muito mais.",
        "es": "Incluso sabiendo que tus alumnos podrían involucrarse mucho más."
    },
    "leaving what matters for later": {
        "en": "Leaving what matters for later",
        "pt": "Deixando o que importa para depois",
        "es": "Dejando lo que importa para después"
    },
    "because planning everything alone ends up taking up too much space in your routine.": {
        "en": "Because planning everything alone ends up taking up too much space in your routine.",
        "pt": "Porque planejar tudo sozinha acaba ocupando espaço demais na sua rotina.",
        "es": "Porque planificar todo sola termina ocupando demasiado espacio en tu rutina."
    },
    "real help": {
        "en": "Real help",
        "pt": "Uma ajuda de verdade",
        "es": "Una ayuda de verdad"
    },
    "the right material changes": {
        "en": "The right material changes",
        "pt": "O material certo muda",
        "es": "El material correcto cambia"
    },
    "the routine.": {
        "en": "the routine.",
        "pt": "a rotina.",
        "es": "la rutina."
    },
    "more time": {
        "en": "More time",
        "pt": "Mais tempo",
        "es": "Más tiempo"
    },
    "have ready-to-use materials to reduce time spent searching and preparing content.": {
        "en": "Have ready-to-use materials to reduce time spent searching and preparing content.",
        "pt": "Tenha materiais prontos para diminuir o tempo gasto procurando e preparando conteúdos.",
        "es": "Ten materiales listos para reducir el tiempo empleado en buscar y preparar contenidos."
    },
    "more organization": {
        "en": "More organization",
        "pt": "Mais organização",
        "es": "Más organización"
    },
    "find files clearly and enjoy a structure that is easier to use.": {
        "en": "Find files clearly and enjoy a structure that is easier to use.",
        "pt": "Encontre os arquivos de forma clara e tenha uma estrutura mais fácil de usar.",
        "es": "Encuentra los archivos claramente y ten una estructura más fácil de usar."
    },
    "more freedom": {
        "en": "More freedom",
        "pt": "Mais liberdade",
        "es": "Más libertad"
    },
    "adapt materials for your students without having to start from scratch.": {
        "en": "Adapt materials for your students without having to start from scratch.",
        "pt": "Adapte os materiais para os seus alunos sem precisar começar tudo do zero.",
        "es": "Adapta los materiales para tus alumnos sin tener que empezar desde cero."
    },
    "more confidence": {
        "en": "More confidence",
        "pt": "Mais segurança",
        "es": "Más seguridad"
    },
    "step into the classroom knowing you have a prepared structure to support your lesson.": {
        "en": "Step into the classroom knowing you have a prepared structure to support your lesson.",
        "pt": "Entre em sala sabendo que você tem uma estrutura preparada para apoiar sua aula.",
        "es": "Entra al aula sabiendo que tienes una estructura preparada para respaldar tu clase."
    },
    "choose yours": {
        "en": "Choose yours",
        "pt": "Escolha o seu",
        "es": "Elige el tuyo"
    },
    "materials to make your classes": {
        "en": "Materials to make your classes",
        "pt": "Materiais para deixar suas aulas mais",
        "es": "Materiales para hacer tus clases más"
    },
    "lighter.": {
        "en": "lighter.",
        "pt": "leves.",
        "es": "ligeras."
    },
    "find materials designed for different moments of your routine. You choose what you need and access the contents available in your package.": {
        "en": "Find materials designed for different moments of your routine. You choose what you need and access the contents available in your package.",
        "pt": "Encontre materiais pensados para diferentes momentos da sua rotina. Você escolhe o que precisa e acessa os conteúdos disponíveis no seu pacote.",
        "es": "Encuentra materiales diseñados para diferentes momentos de tu rutina. Eliges lo que necesitas y accedes a los contenidos disponibles en tu paquete."
    },
    "material": {
        "en": "Material",
        "pt": "Material",
        "es": "Material"
    },
    "content available after release.": {
        "en": "Content available after release.",
        "pt": "Conteúdos disponíveis após a liberação.",
        "es": "Contenido disponible después de la liberación."
    },
    "for": {
        "en": "For",
        "pt": "Por",
        "es": "Por"
    },
    "i want this": {
        "en": "I want this",
        "pt": "Quero este",
        "es": "Quiero este"
    },
    "materials will be available soon.": {
        "en": "Materials will be available soon.",
        "pt": "Os materiais estarão disponíveis em breve.",
        "es": "Los materiales estarán disponibles pronto."
    },
    "organize your routine": {
        "en": "Organize your routine",
        "pt": "Organize sua rotina",
        "es": "Organiza tu rutina"
    },
    "everything organized in": {
        "en": "Everything organized in",
        "pt": "Tudo organizado em",
        "es": "Todo organizado en"
    },
    "one place.": {
        "en": "one place.",
        "pt": "um só lugar.",
        "es": "un solo lugar."
    },
    "each material was designed so you can quickly find what you need without jumping between files, folders, and searches.": {
        "en": "Each material was designed so you can quickly find what you need without jumping between files, folders, and searches.",
        "pt": "Cada material foi pensado para que você consiga encontrar rapidamente o que precisa, sem ficar pulando entre arquivos, pastas e pesquisas.",
        "es": "Cada material fue diseñado para que puedas encontrar rápidamente lo que necesitas, sin saltar entre archivos, carpetas e búsquedas."
    },
    "view materials": {
        "en": "View materials",
        "pt": "Ver materiais",
        "es": "Ver materiales"
    },
    "ready-to-use materials": {
        "en": "Ready-to-use materials",
        "pt": "Materiais prontos para usar",
        "es": "Materiales listos para usar"
    },
    "activities and visual resources": {
        "en": "Activities and visual resources",
        "pt": "Atividades e recursos visuais",
        "es": "Actividades y recursos visuales"
    },
    "organized content": {
        "en": "Organized content",
        "pt": "Conteúdos organizados",
        "es": "Contenidos organizados"
    },
    "files to adapt": {
        "en": "Files to adapt",
        "pt": "Arquivos para adaptar",
        "es": "Archivos para adaptar"
    },
    "more time to teach": {
        "en": "More time to teach",
        "pt": "Mais tempo para ensinar",
        "es": "Más tiempo para enseñar"
    },
    "inside the material": {
        "en": "Inside the material",
        "pt": "Dentro do material",
        "es": "Dentro del material"
    },
    "loading material...": {
        "en": "Loading material...",
        "pt": "Carregando material...",
        "es": "Cargando material..."
    },
    "material preview": {
        "en": "Material preview",
        "pt": "Visualização do material",
        "es": "Vista previa del material"
    },
    "select a material": {
        "en": "Select a material",
        "pt": "Selecione um material",
        "es": "Selecciona un material"
    },
    "file preview will appear here.": {
        "en": "File preview will appear here.",
        "pt": "A visualização do arquivo aparecerá aqui.",
        "es": "La vista previa del archivo aparecerá aquí."
    },
    "your routine deserves this": {
        "en": "Your routine deserves this",
        "pt": "Sua rotina merece isso",
        "es": "Tu rutina se merece esto"
    },
    "stop spending hours": {
        "en": "Stop spending hours",
        "pt": "Pare de gastar horas",
        "es": "Deja de pasar horas"
    },
    "searching.": {
        "en": "searching.",
        "pt": "procurando.",
        "es": "buscando."
    },
    "choose the materials that make sense for you and make planning a little lighter.": {
        "en": "Choose the materials that make sense for you and make planning a little lighter.",
        "pt": "Escolha os materiais que fazem sentido para você e deixe o planejamento um pouco mais leve.",
        "es": "Elige los materiales que tengan sentido para ti y haz que la planificación sea un poco más ligera."
    },
    "includes:": {
        "en": "Includes:",
        "pt": "Inclui:",
        "es": "Incluye:"
    },
    "show less": {
        "en": "Show less",
        "pt": "Mostrar menos",
        "es": "Mostrar menos"
    },
    "see all {count} materials": {
        "en": "See all {count} materials",
        "pt": "Ver todos os {count} materiais",
        "es": "Ver todos los {count} materiales"
    },
    "buy now": {
        "en": "Buy now",
        "pt": "Comprar Agora",
        "es": "Comprar ahora"
    },
    "active": {
        "en": "Active",
        "pt": "Ativo",
        "es": "Activo"
    },
    "inactive": {
        "en": "Inactive",
        "pt": "Inativo",
        "es": "Inactivo"
    },
    "see more": {
        "en": "see more",
        "pt": "ver mais",
        "es": "ver mas"
    },
    "included files:": {
        "en": "included files:",
        "pt": "arquivos incluídos:",
        "es": "archivos incluidos:"
    },
    "what is included": {
        "en": "what is included",
        "pt": "o que está incluído",
        "es": "qué está incluido"
    },
    "current topics and pop culture": {
        "en": "current topics and pop culture",
        "pt": "temas atuais e cultura pop",
        "es": "temas actuales y cultura pop"
    },
    "Unknown status": {
        "en": "Unknown status",
        "pt": "Status desconhecido",
        "es": "Estado desconocido"
    },
    "We could not determine the current status of this order. Please check your email or contact support.": {
        "en": "We could not determine the current status of this order. Please check your email or contact support.",
        "pt": "Não foi possível determinar o status atual deste pedido. Por favor, verifique seu e-mail ou entre em contato com o suporte.",
        "es": "No pudimos determinar el estado actual de este pedido. Por favor, revise su correo electrónico o comuníquese con el servicio de soporte."
    },
    "Payment successful!": {
    "en": "Payment successful!",
    "pt": "Pagamento realizado com sucesso!",
    "es": "¡Pago realizado con éxito!"
  },
  "Awaiting payment": {
    "en": "Awaiting payment",
    "pt": "Aguardando pagamento",
    "es": "Esperando el pago"
  },
  "no_status": {
    "en": "no_status",
    "pt": "sem_status",
    "es": "no_estatos"
  },
  "see item": {
    "en": "see item",
    "pt": "ver item",
    "es": "ver item"
  },
  "Payment declined": {
    "en": "Payment declined",
    "pt": "Pagamento recusado",
    "es": "Pago rechazado"
  },
  "There was an issue processing your payment with the card issuer.": {
    "en": "There was an issue processing your payment with the card issuer.",
    "pt": "Ocorreu um problema ao processar seu pagamento junto à emissora do cartão.",
    "es": "Ocurrió un problema al procesar su pago con el emisor de la tarjeta."
  },
  "The payment was not authorized by Mercado Pago.": {
    "en": "The payment was not authorized by Mercado Pago.",
    "pt": "O pagamento não foi autorizado pelo Mercado Pago.",
    "es": "El pago no fue autorizado por Mercado Pago."
  },
  "You can try again by generating a new link:": {
    "en": "You can try again by generating a new link:",
    "pt": "Você pode tentar novamente gerando um novo link:",
    "es": "Puede intentarlo de nuevo generando un nuevo enlace:"
  },
  "TRY AGAIN": {
    "en": "TRY AGAIN",
    "pt": "TENTAR NOVAMENTE",
    "es": "INTENTAR DE NUEVO"
  }
};

export default translations;